﻿import Swiper from './lib/Swiper/swiper-bundle.esm.browser.min.js'
import dayjs from './lib/dayjs.min.js'
import relativeTime from './lib/relativeTime.min.js'
import updateLocale from './lib/updateLocale.min.js'
import sanitizeHtml from './lib/sanitize-html.min.js'
import PullToRefresh from './lib/index.umd.min.js'

import News from './news/News.js'
import Like from './news/Like.js'
import Group from './news/Group.js'
import NewsSeen from './news/NewsSeen.js'

import {
  collapse,
  expand,
  getDisplayDate,
  createImg,
  setDateTime,
  isNullOrWhitespace,
  getIframe,
  getThumbnailURL
} from '../util.js'
import './news/single-news.js'
import './news/preview-news.js'
import './news/single-statistics.js'
import Poll from './news/Poll.js'

const Core = window.Core
const home = document.querySelector('.page-home')

dayjs.extend(relativeTime)
dayjs.extend(updateLocale)
dayjs.updateLocale('en', {
  relativeTime: {
    future: 'om %s',
    past: '%s sedan',
    s: '1 m',
    m: '1 m',
    mm: '%d m',
    h: '1 tim',
    hh: '%d tim',
    d: '1 d',
    dd: '%d d',
    M: '1 mån',
    MM: '%d mån',
    y: '1 år',
    yy: '%d år'
  }
})

let DATA = []
export let PAYLOAD = []
export let MY_LIKES = []
export let USER = {}
const NEWS_LIMIT = 50
let USERS = []

export const createImgModal = (img, slider = null) => {
  Core.UnlockViewport()
  const modal = document.createElement('div')
  modal.className = 'custom-modal img open'

  const inner = document.createElement('div')
  inner.className = 'inner'

  const btnClose = document.createElement('div')
  const closeIcon = document.createElement('i')
  btnClose.className = 'btn-close-modal'
  closeIcon.className = 'fas fa-times'
  btnClose.appendChild(closeIcon)

  modal.appendChild(inner)

  if (slider !== null) {
    const clone = slider.cloneNode(true)

    const videos = clone.querySelectorAll('[data-iframe]')

    videos.forEach(img => {
      const parent = img.parentElement
      parent.classList.add('is-video')

      parent.addEventListener('click', () => {
        const container = document.createElement('div')
        container.className = 'embed-container'
        container.innerHTML = img.dataset.iframe

        parent.replaceChild(container, img)
        parent.classList.remove('is-video')
      })
    })

    inner.appendChild(clone)
    modal.classList.add('with-slider')
  } else if (img.dataset.iframe) {
    const container = document.createElement('div')
    container.className = 'embed-container'
    container.innerHTML = img.dataset.iframe

    inner.appendChild(container)
  } else {
    inner.appendChild(img.cloneNode())
  }

  inner.appendChild(btnClose)
  document.querySelector('.page-home').appendChild(modal)

  if (slider !== null) {
    setupSwiper(true, img.dataset.index) // re-initiate
  }

  document.documentElement.classList.add('no-scroll')
  home.classList.add('no-scroll')

  modal.addEventListener('click', e => {
    if (e.target.dataset.iframe !== undefined) {
      return
    }

    if (!inner.contains(e.target) || btnClose.contains(e.target)) {
      modal.remove()
      document.documentElement.classList.remove('no-scroll')
      home.classList.remove('no-scroll')
      Core.LockViewport()
    }
  })
}

const addEventListeners = () => {
  const btnCreatePost = document.querySelector('#btn-create-post')
  const createNewsWrapper = document.querySelector('.create-news-wrapper')
  const btnCancelNews = document.querySelector('#btn-close-post')
  const newsWrapper = document.querySelector('.news-wrapper')
  const btnCreateNews = document.querySelector('#btn-create-news')
  const btnPreviewNews = document.querySelector('#btn-preview-news')
  const btnSaveGroupHierarchies = document.querySelector(
    '#btn-save-group-hierarchies'
  )
  const btnClearGroupHierarchies = document.querySelector(
    '#btn-clear-group-hierarchies'
  )
  const btnSaveExcludedGroupHierarchies = document.querySelector(
    '#btn-save-excluded-group-hierarchies'
  )
  const btnClearExcludedGroupHierarchies = document.querySelector(
    '#btn-clear-excluded-group-hierarchies'
  )
  const btnSaveIndividualRecipients = document.querySelector(
    '#btn-save-individual-recipients'
  )
  const btnClearIndividualRecipients = document.querySelector(
    '#btn-clear-individual-recipients'
  )
  const create = btnCreatePost.querySelector('.create-post')
  const edit = btnCreatePost.querySelector('.edit-post')
  const save = createNewsWrapper.querySelector('#btn-save-news')
  const validityInputs = document.querySelectorAll('.check-validity')
  const selectFeedBtns = document.querySelectorAll('[data-feed]')

  btnCreatePost.addEventListener('click', () => {
    const newsIsOpen =
      createNewsWrapper.getAttribute('data-collapsed') === 'false'

    btnCreatePost.classList.toggle('active')

    if (newsIsOpen) {
      collapse(createNewsWrapper)
      createNewsWrapper.classList.remove('active')
      create.classList.add('active')
      edit.classList.remove('active')

      save.classList.add('hidden')
      btnCreateNews.classList.remove('hidden')

      clearFields()
    } else {
      if (useSocialWall) {
        const activeFeed = document.querySelector(
          '[data-feed][data-active="true"]'
        ).dataset.feed
        const excludedGroupsWrapper = document
          .querySelector('.select-excluded-groups')
          .closest('.input-wrapper')
        const individualRecipientsWrapper = document
          .querySelector('.select-individual-recipients')
          .closest('.input-wrapper')
        const authorWrapper = document
          .querySelector('[data-name="Author"]')
          .closest('.input-wrapper')
        const interactWrapper = document
          .querySelector('[data-name=CanInteract]')
          .closest('.input-wrapper')
        const pushWrapper = document
          .querySelector('[data-name=IsPush]')
          .closest('.input-wrapper')
        const emailWrapper = document
          .querySelector('[data-name=IsEmail]')
          .closest('.input-wrapper')
        const publishWrapper = document
          .querySelector('[data-name=Created]')
          .closest('.input-wrapper')
        const unPublishWrapper = document
          .querySelector('[data-name=Unpublish]')
          .closest('.input-wrapper')

        if (activeFeed === 'socialWall') {
          excludedGroupsWrapper.classList.add('hidden')
          authorWrapper.classList.add('hidden')
          interactWrapper.classList.add('hidden')
          pushWrapper.classList.add('hidden')
          emailWrapper.classList.add('hidden')
          publishWrapper.classList.add('hidden')
          unPublishWrapper.classList.add('hidden')
          individualRecipientsWrapper.classList.add('hidden')
        } else {
          excludedGroupsWrapper.classList.remove('hidden')
          authorWrapper.classList.remove('hidden')
          interactWrapper.classList.remove('hidden')
          pushWrapper.classList.remove('hidden')
          emailWrapper.classList.remove('hidden')
          publishWrapper.classList.remove('hidden')
          unPublishWrapper.classList.remove('hidden')
          individualRecipientsWrapper.classList.remove('hidden')
        }
      }

      console.log('Setting time...')
      document.querySelector('#publication-date').value = setDateTime()
      expand(createNewsWrapper)
      createNewsWrapper.classList.add('active')
    }

    newsWrapper.style.display = newsIsOpen ? 'flex' : 'none'
  })

  btnCancelNews.addEventListener('click', () => {
    btnCreatePost.classList.remove('active')
    create.classList.add('active')
    edit.classList.remove('active')
    save.classList.add('hidden')
    btnCreateNews.classList.remove('hidden')
    clearFields()
    collapse(createNewsWrapper)
    newsWrapper.style.display = 'flex'

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  })

  btnCreateNews.addEventListener('click', () => {
    if (btnCreateNews.classList.contains('loading')) {
      return
    }

    createNews(0, btnCreateNews)
  })

  btnPreviewNews.addEventListener('click', previewNews)

  btnSaveGroupHierarchies.addEventListener('click', () => {
    document.querySelector('#input-search-group-hierarchies').value = ''

    const checked = []

    document
      .querySelectorAll('#group-hierarchies .checkbox-wrapper input')
      .forEach(x => {
        const wrapper = x.closest('.checkbox-wrapper')

        if (x.checked) {
          checked.push(x.dataset.groupId)
        }

        x.dataset.parent === '0'
          ? wrapper.classList.remove('hidden')
          : wrapper.classList.add('hidden')
        x.parentElement.querySelector('p').textContent = x.dataset.groupName
        x.dataset.hasChildren
          ? wrapper.classList.add('has-children')
          : wrapper.classList.remove('has-children')
      })

    document
      .querySelectorAll('#excluded-group-hierarchies .checkbox-wrapper input')
      .forEach(x => {
        const wrapper = x.closest('.checkbox-wrapper')

        if (checked.includes(x.dataset.groupId)) {
          wrapper.classList.add('input-disabled')
          x.disabled = true
        } else {
          wrapper.classList.remove('input-disabled')
          x.disabled = false
        }
      })

    document.querySelector('#btn-back-one-level').dataset.level = 0
    document.querySelector('#group-breadcrumb').classList.add('hidden')
    document
      .querySelector('#search-text-group-hierarchies')
      .classList.add('hidden')

    checkValidity()
    setSelectedGroupText()
  })

  btnClearGroupHierarchies.addEventListener('click', () => {
    document.querySelector('#input-search-group-hierarchies').value = ''

    document
      .querySelectorAll('#group-hierarchies .checkbox-wrapper input')
      .forEach(x => {
        const wrapper = x.closest('.checkbox-wrapper')

        x.dataset.parent === '0'
          ? wrapper.classList.remove('hidden')
          : wrapper.classList.add('hidden')
        x.parentElement.querySelector('p').textContent = x.dataset.groupName
        x.dataset.hasChildren
          ? wrapper.classList.add('has-children')
          : wrapper.classList.remove('has-children')
      })

    document
      .querySelectorAll('#excluded-group-hierarchies .checkbox-wrapper input')
      .forEach(x => {
        const wrapper = x.closest('.checkbox-wrapper')

        wrapper.classList.remove('input-disabled')
        x.disabled = !x.dataset.canWrite
      })

    clearGroups()
  })

  btnSaveExcludedGroupHierarchies.addEventListener('click', () => {
    document.querySelector('#input-search-excluded-group-hierarchies').value =
      ''

    const checked = []

    document
      .querySelectorAll('#excluded-group-hierarchies .checkbox-wrapper input')
      .forEach(x => {
        const wrapper = x.closest('.checkbox-wrapper')

        if (x.checked) {
          checked.push(x.dataset.groupId)
        }

        x.dataset.parent === '0'
          ? wrapper.classList.remove('hidden')
          : wrapper.classList.add('hidden')
        x.parentElement.querySelector('p').textContent = x.dataset.groupName
        x.dataset.hasChildren
          ? wrapper.classList.add('has-children')
          : wrapper.classList.remove('has-children')
      })

    document
      .querySelectorAll('#group-hierarchies .checkbox-wrapper input')
      .forEach(x => {
        const wrapper = x.closest('.checkbox-wrapper')

        if (checked.includes(x.dataset.groupId)) {
          wrapper.classList.add('input-disabled')
          x.disabled = true
        } else {
          wrapper.classList.remove('input-disabled')
          x.disabled = false
        }
      })

    document.querySelector('#excluded-btn-back-one-level').dataset.level = 0
    document.querySelector('#excluded-group-breadcrumb').classList.add('hidden')
    document
      .querySelector('#search-text-excluded-group-hierarchies')
      .classList.add('hidden')

    checkValidity()
    setSelectedGroupText(true)
  })

  btnClearExcludedGroupHierarchies.addEventListener('click', () => {
    document.querySelector('#input-search-excluded-group-hierarchies').value =
      ''
    document
      .querySelectorAll('#excluded-group-hierarchies .checkbox-wrapper input')
      .forEach(x => {
        const wrapper = x.closest('.checkbox-wrapper')

        x.dataset.parent === '0'
          ? wrapper.classList.remove('hidden')
          : wrapper.classList.add('hidden')
        x.parentElement.querySelector('p').textContent = x.dataset.groupName
        x.dataset.hasChildren
          ? wrapper.classList.add('has-children')
          : wrapper.classList.remove('has-children')
      })

    document
      .querySelectorAll('#group-hierarchies .checkbox-wrapper input')
      .forEach(x => {
        const wrapper = x.closest('.checkbox-wrapper')

        wrapper.classList.remove('input-disabled')
        x.disabled = !x.dataset.canWrite
      })

    clearGroups(true)
    checkValidity()
  })

  btnSaveIndividualRecipients.addEventListener('click', () => {
    document.querySelector('#input-search-individual-recipients').value = ''

    checkValidity()
    setSelectedIndividualRecipients()
  })

  btnClearIndividualRecipients.addEventListener('click', () => {
    document.querySelector('#input-search-individual-recipients').value = ''
    document.querySelectorAll('#individual-recipients input').forEach(x => {
      x.checked = false
    })
    setSelectedIndividualRecipients()
  })

  save.addEventListener('click', () => {
    createNews(save.dataset.id, save)
  })

  validityInputs.forEach(el => {
    el.addEventListener('keyup', () => {
      checkValidity()
    })
  })

  selectFeedBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const isActive = btn.dataset.active === 'true'
      const btnCreatePost = document.querySelector('#btn-create-post')

      if (
        btnCreatePost.classList.contains('active') &&
        !btnCreatePost.style.display !== 'none'
      ) {
        btnCreatePost.click()
      }

      if (isActive) {
        return
      }

      const clickOnSocialWall = btn.dataset.feed === 'socialWall'
      const socialWallInfo = document.querySelector('.social-wall-info')

      if (clickOnSocialWall && socialWallInfo !== null) {
        socialWallInfo.classList.remove('hidden')
      } else if (socialWallInfo !== null) {
        socialWallInfo.classList.add('hidden')
      }

      selectFeedBtns.forEach(b => {
        b.dataset.active = 'false'
        b.classList.remove('select-feed__btn--active')
      })

      btn.dataset.active = 'true'
      btn.classList.add('select-feed__btn--active')

      document
        .querySelectorAll('.single-news')
        .forEach(el => el.classList.toggle('hidden'))
      document
        .querySelectorAll('.single-news-author')
        .forEach(el => el.classList.toggle('hidden'))

      if (
        btnCreatePost.style.display === 'none' ||
        btnCreatePost.style.display === 'block'
      ) {
        btnCreatePost.style.display =
          btn.dataset.feed === 'socialWall' ? 'block' : 'none'
      }
    })
  })
}

const setSelectedGroupText = (isExcluded = false) => {
  const id = isExcluded ? 'excluded-group-hierarchies' : 'group-hierarchies'
  const selectClass = isExcluded
    ? 'select-excluded-groups.select'
    : 'select-groups.select'

  const inputs = document.querySelectorAll(`#${id} input`)
  const target = document.querySelector(`.${selectClass}`)
  const checked = [...inputs].filter(x => x.checked).map(x => x.value)
  const str = checked.join(', ')

  target.textContent = str.length === 0 ? lang_select : str

  if (str.length > 30) {
    let trimmed = str.substring(0, 30)
    trimmed = trimmed.substring(
      0,
      Math.min(trimmed.length, trimmed.lastIndexOf(' '))
    ) // re-trim if middle of a word

    trimmed =
      trimmed.slice(-1) === ',' ? `${trimmed.slice(0, -1)}...` : `${trimmed}...`

    target.textContent = `${trimmed} +${
      checked.length - trimmed.split(' ').length
    }`
  }
}

function setSelectedIndividualRecipients () {
  const inputs = document.querySelectorAll('#individual-recipients input')
  const target = document.querySelector('.select-individual-recipients.select')

  const checked = [...inputs].filter(x => x.checked).map(x => x.value)
  const str = checked.join(', ')

  target.textContent = str.length === 0 ? lang_select : str

  if (str.length > 30) {
    let trimmed = str.substring(0, 30)
    trimmed = trimmed.substring(
      0,
      Math.min(trimmed.length, trimmed.lastIndexOf(' '))
    ) // re-trim if middle of a word

    trimmed =
      trimmed.slice(-1) === ',' ? `${trimmed.slice(0, -1)}...` : `${trimmed}...`

    target.textContent = `${trimmed} +${
      checked.length - trimmed.split(' ').length
    }`
  }
}

const clearGroups = (isExcluded = false) => {
  const hierarchies = document.querySelectorAll('#group-hierarchies input')
  const excludedHierarchies = document.querySelectorAll(
    '#excluded-group-hierarchies input'
  )

  if (isExcluded) {
    document.querySelector('#excluded-btn-back-one-level').dataset.level = 0
    document.querySelector('#excluded-group-breadcrumb').classList.add('hidden')
    document.querySelector('#btn-save-excluded-group-hierarchies').textContent =
      lang_select_recipient
    document
      .querySelector('#search-text-excluded-group-hierarchies')
      .classList.add('hidden')
    document.querySelector('.select-excluded-groups.select').textContent =
      lang_select

    for (let i = 0; i < excludedHierarchies.length; i++) {
      excludedHierarchies[i].checked = false
    }
  } else {
    const recievers = document.querySelector('#number-of-recievers')
    document.querySelector('#btn-back-one-level').dataset.level = 0
    document.querySelector('#group-breadcrumb').classList.add('hidden')
    document.querySelector('#btn-save-group-hierarchies').textContent =
      lang_select_recipient
    recievers.textContent = `0 ${lang_recipient}`
    recievers.dataset.value = 0
    document.querySelector('.select-groups.select').textContent = lang_select
    document.querySelector('.select-individual-recipients').textContent =
      lang_select
    document
      .querySelector('#search-text-group-hierarchies')
      .classList.add('hidden')

    for (let i = 0; i < hierarchies.length; i++) {
      hierarchies[i].checked = false
    }
  }
}

const handleFileUpload = async node => {
  const files = node.files

  if (files.length) {
    const filesContainer = document.querySelector('.files-container')

    for (let i = 0; i < files.length; i++) {
      const item = document.createElement('div')
      item.className = 'item'

      const btnClose = document.createElement('div')
      const closeIcon = document.createElement('i')
      btnClose.className = 'btn-close'
      closeIcon.className = 'fas fa-times'
      btnClose.appendChild(closeIcon)

      const img = document.createElement('img')
      img.dataset.name = 'Images'
      img.dataset.extension = 'jpg'
      img.dataset.deleted = false
      img.dataset.id = 0

      await createImg(img, files[i], 2400, 2400)

      img.addEventListener('click', () => {
        createImgModal(img)
      })

      btnClose.addEventListener('click', () => {
        filesContainer.removeChild(item)
      })

      item.appendChild(btnClose)
      item.appendChild(img)
      filesContainer.appendChild(item)
    }
  }
}

async function pinNews (newsId) {
  try {
    const res = await window.fetch(`/HR/api/pinnews.aspx?news-id=${newsId}`)

    if (!res.ok) {
      console.error(res.statusText)
    }

    const data = await res.json()

    if (data === null || data.StatusCode !== 200) {
      console.error(data.Message)
    }

    setPinnedNews(newsId)
  } catch (err) {
    console.error(err)
  }
}

function setPinnedNews (newsId) {
  const newsInPayload = PAYLOAD.find(x => x.ID === newsId)
  newsInPayload.Pinned = !newsInPayload.Pinned
  const newsInList = document.querySelector(
    `.single-news[data-id='${newsInPayload.ID}']`
  )
  newsInList.dataset.pinned = newsInPayload.Pinned
  const newsAuthor = newsInList.previousElementSibling

  newsInList.classList.toggle('single-news--pinned')

  const pinned = newsInList.querySelector('.single-news-pinned')
  pinned.classList.toggle('hidden')

  const newsWrapper = document.querySelector('.news-wrapper')

  if (newsInPayload.Pinned) {
    const unpublishedNews = document.querySelectorAll(
      '.single-news.not-published'
    )

    if (unpublishedNews.length === 0) {
      // Insert pinned news at the top
      newsWrapper.prepend(newsInList)
    } else {
      // Insert pinned news after the last unpublished news
      const lastUnpublished = unpublishedNews[unpublishedNews.length - 1]

      lastUnpublished.insertAdjacentElement('afterend', newsInList)
    }

    if (newsAuthor && newsAuthor.classList.contains('single-news-author')) {
      newsInList.insertAdjacentElement('beforebegin', newsAuthor)
    }

    return
  }

  const allNews = document.querySelectorAll('.single-news')

  // Find where to insert by comparing the publish date
  for (let i = 0; i < allNews.length; i++) {
    const news = allNews[i]
    const publishDate = news.getAttribute('data-publish-date')

    if (
      dayjs(newsInPayload.Created).isAfter(dayjs(publishDate)) &&
      news.dataset.pinned === 'false'
    ) {
      const author = news.previousElementSibling

      if (author && author.classList.contains('single-news-author')) {
        author.insertAdjacentElement('beforebegin', newsInList)
      } else {
        news.insertAdjacentElement('beforebegin', newsInList)
      }
      break
    }
  }

  // Also move author
  if (newsAuthor && newsAuthor.classList.contains('single-news-author')) {
    newsInList.insertAdjacentElement('beforebegin', newsAuthor)
  }
}

export const showStats = newsID => {
  const news = new News(PAYLOAD.filter(x => x.ID === newsID)[0])

  const singleStats = document.createElement('single-statistics')
  singleStats.dataset.newsId = news.ID

  document.querySelector('.page-home').appendChild(singleStats)
  document.documentElement.classList.add('no-scroll')
  home.classList.add('no-scroll')
}

const openSingleNews = (newsID, isComment = false) => {
  const news = new News(PAYLOAD.filter(x => x.ID === newsID)[0])

  const singleNews = document.createElement('single-news')
  singleNews.dataset.id = news.ID
  singleNews.dataset.focusInput = isComment
  singleNews.dataset.interactable = news.CanInteract
  singleNews.dataset.hasSeen = news.UserHasSeen

  document.querySelector('.page-home').appendChild(singleNews)
  document.documentElement.classList.add('no-scroll')
  home.classList.add('no-scroll')
}

const setupNews = async (payload, loadMore = false, dto = null) => {
  const createNewsWrapper = document.querySelector('.create-news-wrapper')
  const btnCreateNews = document.querySelector('#btn-create-news')

  createNewsWrapper.style.top =
    btnCreateNews.getBoundingClientRect().bottom + 'px'

  if (payload.length === 0) {
    return
  }

  const newsWrapper = document.querySelector('.news-wrapper')

  if (!loadMore) {
    newsWrapper.innerHTML = ''
  }

  for (let i = 0; i < payload.length; i++) {
    const news = new News(payload[i])

    news.Videos = JSON.parse(news.Videos)

    const notPublished = dayjs(news.Created).isAfter(dayjs()) // if created is after today

    const newsItem = document.createElement('div')
    newsItem.className = `single-news${notPublished ? ' not-published' : ''}`

    !news.IsSocialWall
      ? newsItem.classList.remove('hidden')
      : newsItem.classList.add('hidden')

    if (news.Pinned) {
      newsItem.classList.add('single-news--pinned')
    }

    newsItem.dataset.id = news.ID
    newsItem.dataset.hasSeen = news.UserHasSeen
    newsItem.dataset.publishDate = news.Created
    newsItem.dataset.pinned = news.Pinned

    const btnNewsOptions = document.createElement('div')
    btnNewsOptions.className = 'single-news-btn-options'
    const editIcon = document.createElement('i')
    editIcon.className = 'fas fa-ellipsis-h'

    const optionsInner = document.createElement('div')
    optionsInner.className = 'single-news-options-inner'
    optionsInner.setAttribute('data-collapsed', 'true')

    const close = document.createElement('div')
    close.className = 'single-news-options-close'

    const closeIcon = document.createElement('i')
    closeIcon.className = 'fas fa-times'
    close.appendChild(closeIcon)

    const edit = document.createElement('div')
    edit.className = 'single-news-edit option'
    edit.textContent = lang_edit_post

    const del = document.createElement('div')
    del.className = 'single-news-delete option'
    del.textContent = notPublished ? lang_remove_post : lang_unpublish_post

    edit.addEventListener('click', () => editNews(news.ID))

    del.addEventListener('click', () => {
      collapse(optionsInner)
      document.documentElement.classList.add('no-scroll')
      home.classList.add('no-scroll')

      const modalUnpublish = document.querySelector('.modal-unpublish')
      modalUnpublish.querySelector('#button-unpublish').dataset.newsid = news.ID
      modalUnpublish.classList.add('open')
    })

    document.addEventListener('click', e => {
      const isClickInside = optionsInner.contains(e.target)
      const isClickInsideBtn = btnNewsOptions.contains(e.target)
      const optionsIsOpen =
        optionsInner.getAttribute('data-collapsed') === 'false'

      if (!isClickInside && optionsIsOpen && !isClickInsideBtn) {
        collapse(optionsInner)
      }
    })

    btnNewsOptions.addEventListener('click', () => {
      const optionsIsOpen =
        optionsInner.getAttribute('data-collapsed') === 'false'

      optionsIsOpen ? collapse(optionsInner) : expand(optionsInner)
    })

    close.addEventListener('click', () => {
      collapse(optionsInner)
    })

    optionsInner.appendChild(close)
    optionsInner.appendChild(edit)
    optionsInner.appendChild(del)

    if (!news.IsSocialWall) {
      const stats = document.createElement('div')
      stats.className = 'single-news-stats option'
      stats.textContent = lang_show_statistics

      stats.addEventListener('click', () => {
        collapse(optionsInner)
        showStats(news.ID)
      })

      const pin = document.createElement('div')
      pin.className = 'single-news-pin option'
      pin.textContent = news.Pinned ? lang_unpin_news : lang_pin_news

      pin.addEventListener('click', () => {
        pin.textContent =
          pin.textContent === lang_unpin_news ? lang_pin_news : lang_unpin_news

        collapse(optionsInner)
        void pinNews(news.ID)
      })

      optionsInner.appendChild(stats)
      optionsInner.appendChild(pin)
    }

    btnNewsOptions.appendChild(editIcon)

    if (news.UserIDRef === USER.UserID || USER.Admin === true) {
      newsItem.appendChild(btnNewsOptions)
    }
    newsItem.appendChild(optionsInner)

    if (news.Author !== '0') {
      const author = document.createElement('p')
      author.className = 'single-news-author'

      !news.IsSocialWall
        ? author.classList.remove('hidden')
        : author.classList.add('hidden')

      author.textContent = `${lang_posted_by}: ` + news.Author
      newsItem.appendChild(author)
    }

    const pinned = document.createElement('div')
    pinned.className = news.Pinned
      ? 'single-news-pinned'
      : 'single-news-pinned hidden'

    const pinnedIcon = document.createElement('i')
    pinnedIcon.className = 'fa-solid fa-thumbtack'

    const pinnedText = document.createTextNode(lang_pinned)

    pinned.append(pinnedIcon, pinnedText)
    newsItem.appendChild(pinned)

    const read = document.createElement('div')
    read.className = 'single-news-read'
    read.dataset.visible = !news.UserHasSeen
    read.textContent = lang_unread

    newsItem.appendChild(read)

    if (newsItem.classList.contains('not-published')) {
      const notPublished = document.createElement('p')
      notPublished.className = 'single-news-not-published'
      notPublished.textContent = lang_not_published
      newsItem.appendChild(notPublished)
    }

    if (news.HasPoll) {
      const poll = new Poll(JSON.parse(news.Poll))
      const pollEnded = dayjs(poll.endDate).isBefore(dayjs())

      const pollHeading = document.createElement('p')
      pollHeading.className = 'single-news-poll-title'

      const i = document.createElement('i')
      i.className = 'fa-solid fa-chart-column'

      const span = document.createElement('span')

      if (pollEnded) {
        span.textContent = lang_finished_poll
        pollHeading.classList.add('ended')
      } else {
        span.textContent = lang_ongoing_poll
      }

      pollHeading.appendChild(i)
      pollHeading.appendChild(span)
      newsItem.appendChild(pollHeading)
    }

    const title = document.createElement('p')
    title.className = 'single-news-title'
    title.textContent = news.Title

    newsItem.appendChild(title)

    const date = document.createElement('p')
    date.className = 'single-news-created'
    date.textContent = notPublished
      ? `${lang_publishes}: ${getDisplayDate(news.Updated)}`
      : getDisplayDate(news.Updated)
    newsItem.appendChild(date)

    const toWrapper = document.createElement('div')
    toWrapper.className = 'single-news-to'

    const userGroup = document.createElement('i')
    userGroup.className = 'fas fa-user-friends'

    const toFull = document.createElement('p')
    toFull.className = 'single-news-to-full'
    toFull.textContent = news.Groups.filter(x => !x.isExcluded)
      .map(x => x.groupName)
      .join(', ')

    toWrapper.append(userGroup)
    toWrapper.append(toFull)

    newsItem.appendChild(toWrapper)

    const preamble = document.createElement('div')
    preamble.className = 'single-news-preamble'
    preamble.innerHTML = news.Contents

    preamble.querySelectorAll('a').forEach(a => {
      a.target = '_blank'
    })

    if (
      news.Contents.length > 300 &&
      !news.Contents.includes('youtube-embed-wrapper')
    ) {
      let trimmed = news.Contents.substring(0, 300)
      trimmed = trimmed.substring(
        0,
        Math.min(trimmed.length, trimmed.lastIndexOf(' '))
      ) // re-trim if middle of a word
      trimmed = trimmed.slice(-1) === '.' ? `${trimmed}..` : `${trimmed}...`
      preamble.innerHTML = trimmed
    }

    newsItem.appendChild(preamble)

    if (
      news.Contents.length > 300 &&
      !news.Contents.includes('youtube-embed-wrapper')
    ) {
      const readMore = document.createElement('p')
      readMore.className = 'single-news-read-more'
      readMore.innerHTML = `${lang_read_more} <i class="fa-sharp-duotone fa-solid fa-chevrons-right"></i>`

      preamble.appendChild(readMore)
    }

    if (news.HasPoll) {
      const poll = new Poll(JSON.parse(news.Poll))

      const pollHasEnded = dayjs(poll.endDate).isBefore(dayjs())

      const parent = document.createElement('div')
      parent.className = 'single-news-poll'

      const wrapper = document.createElement('div')
      wrapper.className = 'poll__wrapper'

      const question = document.createElement('p')
      question.className = 'poll__question'
      question.textContent = poll.question

      wrapper.appendChild(question)

      const answerWrapper = document.createElement('div')
      answerWrapper.className = 'poll__answer-wrapper'

      const id = (Math.random() + 1).toString(36).substring(2)

      const res = await window.fetch(`/HR/api/pollvote.aspx?news-id=${news.ID}`)
      const answerData = await res.json()

      const userVote = answerData.find(
        x => x.NewsId === news.ID && x.UserId === USER.UserID
      )
      const userHasVoted = userVote !== undefined

      for (let i = 0; i < poll.answers.length; i++) {
        const wrap = document.createElement('div')
        wrap.className = 'poll__single-answer-wrapper'

        if (!pollHasEnded && !userHasVoted) {
          const input = document.createElement('input')
          input.type = poll.multipleAnswers === 'true' ? 'checkbox' : 'radio'
          input.name = id
          input.value = poll.answers[i]
          input.id = `${id}-${i}`
          input.dataset.index = i

          const label = document.createElement('label')
          label.setAttribute('for', `${id}-${i}`)
          label.textContent = poll.answers[i]

          wrap.appendChild(input)
          wrap.appendChild(label)
        } else {
          const answer = document.createElement('div')
          answer.className = 'poll__answer'
          answer.textContent = poll.answers[i]
          answer.dataset.index = i

          if (
            userHasVoted &&
            userVote.Answers.filter(x => x.AnswerId === i).length > 0
          ) {
            answer.classList.add('poll__answer-active')
          }

          wrap.appendChild(answer)
        }

        answerWrapper.appendChild(wrap)
      }

      wrapper.appendChild(answerWrapper)

      const errorText = document.createElement('p')
      errorText.className = 'poll__error-text hidden'
      errorText.textContent = lang_choose_option

      wrapper.appendChild(errorText)

      const thanks = document.createElement('p')
      thanks.className = 'poll__vote-thanks hidden'
      thanks.textContent = lang_thank_you_vote
      wrapper.appendChild(thanks)

      if (userHasVoted) {
        thanks.classList.remove('hidden')
      }

      if (!pollHasEnded && !userHasVoted) {
        const voteButton = document.createElement('div')
        voteButton.className = 'button-round blue'
        voteButton.textContent = lang_vote

        wrapper.appendChild(voteButton)

        voteButton.addEventListener('click', async () => {
          const answers = [...answerWrapper.querySelectorAll('input')]
            ?.filter(x => x.checked)
            ?.map(x => {
              return {
                AnswerId: x.dataset.index,
                AnswerText: x.value
              }
            })

          answers.length === 0
            ? errorText.classList.remove('hidden')
            : errorText.classList.add('hidden')

          if (answers.length === 0) {
            return
          }

          const obj = {
            NewsId: news.ID,
            UserId: USER.UserID,
            Answers: answers
          }

          voteButton.remove()
          thanks.classList.remove('hidden')

          createHasSeen(news)

          window
            .fetch('/HR/api/pollvote.aspx', {
              method: 'POST',
              body: JSON.stringify(obj),
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then(res => res.text())
            .then(data => {})
            .catch(err => {
              console.error(err)

              voteButton.remove()
              thanks.className = 'poll__vote-err'
              thanks.textContent = lang_something_went_wrong
            })
        })
      }

      const infoText = document.createElement('p')
      infoText.className = 'poll__info-text'
      infoText.textContent = pollHasEnded
        ? lang_poll_ended
        : `${lang_poll_ends} ${getDisplayDate(poll.endDate).toLowerCase()}`

      wrapper.appendChild(infoText)
      parent.appendChild(wrapper)
      newsItem.appendChild(parent)

      if (userHasVoted || pollHasEnded) {
        const votes = answerData.map(x => x.Answers.map(y => y.AnswerId)).flat()

        setupPollStats(poll, votes, newsItem, news.UserIDRef)
      }
    }

    title.addEventListener('click', () => openSingleNews(news.ID))
    date.addEventListener('click', () => openSingleNews(news.ID))
    preamble.addEventListener('click', () => openSingleNews(news.ID))

    const mediaLength = news.Images.length + news.Videos.length

    if (mediaLength !== 0) {
      const imgWrap = document.createElement('div')
      imgWrap.className = 'image-wrap'

      if (mediaLength === 1) {
        if (news.Images.length) {
          const img = document.createElement('img')
          img.src = `/FILEARCHIVE/${news.Images[0].Src}`
          img.loading = 'lazy'
          imgWrap.appendChild(img)

          img.addEventListener('click', () => {
            createImgModal(img)
          })
        } else if (news.Videos.length) {
          const vid = news.Videos[0]
          const thumbnailURL = getThumbnailURL(vid.Type, vid.URL)

          const img = document.createElement('img')
          img.src = thumbnailURL
          img.loading = 'lazy'
          img.dataset.iframe = getIframe(vid.Type, vid.URL).innerHTML
          imgWrap.classList.add('is-video')

          // const videoContainer = getIframe(vid.Type, vid.URL)

          img.addEventListener('click', () => {
            createImgModal(img)
          })

          imgWrap.appendChild(img)
        }
      } else {
        const swiperDiv = document.createElement('div')
        swiperDiv.className = 'swiper'

        const swiperWrapper = document.createElement('div')
        swiperWrapper.className = 'swiper-wrapper'

        const imgs = []
        let jcount = 0
        for (let j = 0; j < news.Images.length; j++) {
          const swiperSlide = document.createElement('div')
          swiperSlide.className = 'swiper-slide'

          const img = document.createElement('img')
          img.src = `/FILEARCHIVE/${news.Images[j].Src}`
          img.loading = 'lazy'
          img.dataset.index = jcount
          imgs.push(img)

          swiperSlide.appendChild(img)
          swiperWrapper.appendChild(swiperSlide)
          jcount++
        }

        for (let j = 0; j < news.Videos.length; j++) {
          const swiperSlide = document.createElement('div')
          swiperSlide.className = 'swiper-slide is-video'

          const vid = news.Videos[j]
          const thumbnailURL = getThumbnailURL(vid.Type, vid.URL)

          const img = document.createElement('img')
          img.src = thumbnailURL
          img.dataset.iframe = getIframe(vid.Type, vid.URL).innerHTML
          img.dataset.index = jcount
          img.loading = 'lazy'
          imgs.push(img)

          swiperSlide.appendChild(img)
          swiperWrapper.appendChild(swiperSlide)
          jcount++
        }

        swiperDiv.appendChild(swiperWrapper)

        for (let j = 0; j < imgs.length; j++) {
          imgs[j].addEventListener('click', () => {
            createImgModal(imgs[j], swiperDiv)
          })
        }

        imgWrap.appendChild(swiperDiv)
      }

      newsItem.appendChild(imgWrap)
    }

    if (news.CanInteract) {
      const socialWrap = document.createElement('div')
      socialWrap.className = 'social-wrap'

      socialWrap.addEventListener('click', () => openSingleNews(news.ID))

      const likes = document.createElement('div')
      likes.className = 'single-news-likes'

      const likeIcon = document.createElement('i')
      likeIcon.className = 'fas fa-thumbs-up'

      const likeSpan = document.createElement('span')
      likeSpan.textContent = news.Likes + ` ${lang_likes_this}`

      likes.appendChild(likeIcon)
      likes.appendChild(likeSpan)

      const comments = document.createElement('div')
      comments.className = 'single-news-comments'

      const commentIcon = document.createElement('i')
      commentIcon.className = 'fas fa-comment'

      const commentSpan = document.createElement('span')
      commentSpan.textContent =
        news.Comments === 1
          ? news.Comments + ` ${lang_a_comment}`
          : news.Comments + ` ${lang_comments}`

      comments.appendChild(commentIcon)
      comments.appendChild(commentSpan)

      socialWrap.appendChild(likes)
      socialWrap.appendChild(comments)

      const buttonWrap = document.createElement('div')
      buttonWrap.className = 'single-news-btn-wrap'

      const likeBtn = document.createElement('div')
      likeBtn.className = 'single-news-btn-like'

      if (MY_LIKES.filter(x => x.NewsRef === news.ID).length !== 0) {
        likeBtn.classList.add('active')
      }

      likeBtn.addEventListener('click', () => {
        likeBtn.classList.toggle('active')

        const like = new Like()
        like.UserIDRef = USER.UserID
        like.NewsRef = news.ID
        like.UserName = `${USER.FirstName} ${USER.LastName}`
        like.Created = dayjs().format()

        if (likeBtn.classList.contains('active')) {
          payload[i].Likes++
          likeSpan.textContent = `${payload[i].Likes} ${lang_likes_this}`

          createHasSeen(news)
        } else {
          payload[i].Likes--
          likeSpan.textContent = `${payload[i].Likes} ${lang_likes_this}`
        }

        handleLike(like)
      })

      const likeBtnSpan = document.createElement('span')
      likeBtnSpan.textContent = lang_like

      likeBtn.appendChild(likeIcon.cloneNode())
      likeBtn.appendChild(likeBtnSpan)

      const commentBtn = document.createElement('div')
      commentBtn.className = 'single-news-btn-comment'

      commentBtn.addEventListener('click', () => openSingleNews(news.ID, true))

      const commentBtnSpan = document.createElement('span')
      commentBtnSpan.textContent = lang_comment

      commentBtn.appendChild(commentIcon.cloneNode())
      commentBtn.appendChild(commentBtnSpan)

      buttonWrap.appendChild(likeBtn)
      buttonWrap.appendChild(commentBtn)

      newsItem.appendChild(socialWrap)
      newsItem.appendChild(buttonWrap)
    }

    newsWrapper.appendChild(newsItem)

    const author = newsItem.querySelector('.single-news-author')

    if (author !== null) {
      newsItem.insertAdjacentElement('beforebegin', author)
    }
  }

  const sourceDto = dto || DATA
  maybeShowLoadMore(sourceDto, newsWrapper)

  if (!loadMore) {
    document.dispatchEvent(new CustomEvent('newsLoaded'))
  }
}

let nextOffset = 0

function maybeShowLoadMore (data, newsWrapper) {
  if (!data.hasMore) {
    return
  }

  const {
    loadMoreBtn,
    loadMoreBtnText,
    loadMoreBtnIcon
  } =
    renderLoadMore(newsWrapper)

  loadMoreBtn.addEventListener('click', () => {
    if (loadMoreBtn.dataset.clicked === 'true') {
      return
    }

    loadMoreBtn.dataset.clicked = 'true'
    loadMoreBtnText.style.display = 'none'
    loadMoreBtnIcon.style.display = 'inline-block'

    if (useSocialWall) {
      document.querySelector('.select-feed__btn[data-feed="news"]').click()
    }

    window
      .fetch(`/HR/api/getmynews.aspx?limit=${NEWS_LIMIT}&offset=${nextOffset}`)
      .then(res => res.json())
      .then(data => {
        // keep global paging state in sync with latest response
        DATA = data
        nextOffset = data.nextOffset
        PAYLOAD = PAYLOAD.concat(data.items)
        setupNews(data.items, true, data)

        // if still more, add another button
        // next button is rendered by setupNews based on `data`
      })
      .catch(err => console.error(err))
      .finally(() => {
        loadMoreBtn.remove()
      })
  })
}

function renderLoadMore (newsWrapper) {
  const loadMoreBtn = document.createElement('div')
  loadMoreBtn.className = 'btn btn--load-more'
  loadMoreBtn.dataset.clicked = 'false'

  const loadMoreBtnText = document.createElement('span')
  loadMoreBtnText.textContent = lang_load_more

  const loadMoreBtnIcon = document.createElement('i')
  loadMoreBtnIcon.className = 'fa-solid fa-spinner fa-spin'
  loadMoreBtnIcon.style.display = 'none'

  loadMoreBtn.append(loadMoreBtnText, loadMoreBtnIcon)
  newsWrapper.appendChild(loadMoreBtn)

  return {
    loadMoreBtn,
    loadMoreBtnText,
    loadMoreBtnIcon
  }
}

export const handleLike = like => {
  window
    .fetch('/HR/api/createlike.aspx', {
      method: 'POST',
      body: JSON.stringify(like),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .catch(err => console.error(err))
}

const checkValidity = () => {
  const title = document.querySelector('[data-name=Title]').value
  let contents = document.querySelector('[data-name=Content]').value
  const groups = document.querySelectorAll(
    '[data-name=GroupHierarchies]:checked'
  )
  const individualRecievers = document.querySelectorAll(
    '[data-name=IndividualRecipients]:checked'
  )

  // if (IS_DESKTOP) {
  contents = window.CKEDITOR.instances.ckcontent.getData()
  // }

  if (
    !isNullOrWhitespace(title) &&
    contents.length > 9 &&
    (groups.length !== 0 || individualRecievers.length !== 0)
  ) {
    document.querySelector('#btn-create-news').classList.add('active')
    document.querySelector('#btn-save-news').classList.add('active')
  } else {
    document.querySelector('#btn-create-news').classList.remove('active')
    document.querySelector('#btn-save-news').classList.remove('active')
  }
}

const previewNews = () => {
  createNews(0, null, true)
}

const createNews = (ID = 0, btn = null, isPreview = false) => {
  const title = document.querySelector('[data-name=Title]').value
  let contents = sanitizeHtml(
    document.querySelector('[data-name=Content]').value
  )

  // if (IS_DESKTOP) {
  contents = window.CKEDITOR.instances.ckcontent.getData()
  // }

  const recievers = document.querySelectorAll(
    '[data-name="GroupHierarchies"]:checked'
  )
  const excludedRecievers = document.querySelectorAll(
    '[data-name="ExcludedGroupHierarchies"]:checked'
  )
  const individualRecievers = document.querySelectorAll(
    '[data-name="IndividualRecipients"]:checked'
  )

  const hierarchies = []

  ;[...recievers].concat([...excludedRecievers]).forEach(x => {
    const exists = hierarchies.some(y => y.groupID === x.dataset.groupId)
    const toBeExcluded = [...excludedRecievers].some(
      y => y.dataset.groupId === x.dataset.groupId
    )

    if (exists && toBeExcluded) {
      hierarchies.find(y => y.groupID === x.dataset.groupId).isExcluded = true
    } else {
      const g = new Group({
        groupID: x.dataset.groupId,
        groupName: x.dataset.groupName,
        canWrite: x.dataset.canWrite === 'true',
        parent: x.dataset.parent,
        hasChildren: x.dataset.hasChildren,
        lvl: x.dataset.lvl,
        access_publicering: x.dataset.access_publicering,
        access_mediearkiv: x.dataset.access_mediearkiv,
        access_produktdatabas: x.dataset.access_produktdatabas,
        access_mailutskick: x.dataset.access_mailutskick,
        access_kontohantering: x.dataset.access_kontohantering,
        access_installningar: x.dataset.access_installningar,
        sort: x.dataset.sort,
        isExcluded: [...excludedRecievers].includes(x)
      })

      hierarchies.push(g)
    }
  })

  const canInteract = document.querySelector('[data-name=CanInteract]:checked')
  const isPush = document.querySelector('[data-name=IsPush]:checked')
  const isEmail = document.querySelector('[data-name=IsEmail]:checked')

  if (
    (isNullOrWhitespace(title) ||
      isNullOrWhitespace(contents) ||
      (recievers.length === 0 && individualRecievers.length === 0) ||
      canInteract == null ||
      isPush == null ||
      isEmail == null) &&
    !isPreview
  ) {
    return
  }

  if (btn !== null) {
    btn.classList.add('loading')
  }

  const news = new News()

  news.Title = title
  news.Contents = contents

  news.Created = dayjs(
    document.querySelector('[data-name=Created]').value
  ).format('YYYY-MM-DDTHH:mm:ss')
  news.Updated = news.Created

  const unpublish = document.querySelector('[data-name=Unpublish]').value

  news.Unpublish =
    unpublish === ''
      ? dayjs(news.Created).add(100, 'year').format('YYYY-MM-DDTHH:mm:ss')
      : dayjs(unpublish).format('YYYY-MM-DDTHH:mm:ss')

  news.Author = document.querySelector('[data-name=Author]:checked').value
  news.CanInteract = canInteract.value
  news.IsPush = isPush.value
  news.IsEmail = isEmail.value
  news.MustSign = document.querySelector('[data-name=MustSign]:checked').value
  news.Groups = hierarchies
  news.Images = [...document.querySelectorAll('[data-name=Images]')].map(x => {
    return {
      ID: x.dataset.id,
      Src: x.getAttribute('src'),
      Extension: x.dataset.extension,
      Deleted: x.dataset.deleted
    }
  })
  news.UserIDRef = USER.UserID
  news.Videos = JSON.stringify(
    [...document.querySelectorAll('[data-name=Video]')].map(x => {
      const input = x.querySelector('input[type=text]')
      const type = x.querySelector('option:checked').value

      return {
        Type: type,
        URL: input.value
      }
    })
  )
  news.Links = JSON.stringify(
    [...document.querySelectorAll('[data-name=Link]')].map(x => {
      const name = x.querySelector('.input-name').value
      const url = x.querySelector('.input-url').value

      return {
        Name: name,
        URL: url
      }
    })
  )
  news.Users = [...individualRecievers].map(x => x.dataset.userId)

  let poll = document.querySelector('#poll__hidden').value

  try {
    JSON.parse(poll)
  } catch (e) {
    poll = '{}'
  }

  news.Poll = poll

  if (useSocialWall) {
    const activeFeed = document.querySelector('[data-feed][data-active="true"]')
      .dataset.feed

    news.IsSocialWall = activeFeed === 'socialWall'
  } else {
    news.IsSocialWall = false
  }

  const url =
    ID === 0 ? '/HR/api/createnews.aspx' : `/HR/api/createnews.aspx?id=${ID}`

  if (isPreview) {
    const previewNews = document.createElement('preview-news')
    previewNews.dataset.data = JSON.stringify(news)
    document.querySelector('.page-home').appendChild(previewNews)
    return
  }

  if (ID !== 0) {
    const newsInPayload = PAYLOAD.find(x => x.ID === Number(ID))
    news.Pinned = newsInPayload.Pinned
  }

  window
    .fetch(url, {
      method: 'POST',
      body: JSON.stringify(news),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(res => {
      if (res.status === 200) {
        const typeofFeed =
          document.querySelector('[data-feed][data-active="true"]')?.dataset
            .feed || 'news'

        if (typeofFeed === 'socialWall') {
          reloadWithQueryString('feed=social-wall')
        } else {
          window.location.reload()
        }
      }
    })
    .catch(err => console.error(err))
}

/**
 *
 * @param {News} news
 */
const setFields = news => {
  const groupIDs = news.Groups.map(e =>
    e.isExcluded ? false : Number(e.groupID)
  )
  const excludedGroupIDs = news.Groups.map(e =>
    e.isExcluded ? Number(e.groupID) : false
  )

  const videos = JSON.parse(news.Videos)
  const links = JSON.parse(news.Links)
  const poll = isNullOrWhitespace(news.Poll)
    ? {}
    : new Poll(JSON.parse(news.Poll))

  const checked = []
  const checkedExcluded = []

  ;[...document.querySelectorAll('[data-name=GroupHierarchies]')].forEach(
    input => {
      input.checked = groupIDs.includes(Number(input.dataset.groupId))

      if (input.checked) {
        checked.push(input.dataset.groupId)
      }
    }
  )
  ;[...document.querySelectorAll('[data-name=ExcludedGroupHierarchies]')].forEach(input => {
    input.checked = excludedGroupIDs.includes(Number(input.dataset.groupId))

    if (input.checked) {
      checkedExcluded.push(input.dataset.groupId)
    }
  })
  ;[...document.querySelectorAll('[data-name=ExcludedGroupHierarchies]')].forEach(input => {
    const wrapper = input.closest('.checkbox-wrapper')

    if (checked.includes(input.dataset.groupId)) {
      wrapper.classList.add('input-disabled')
      input.disabled = true
    } else {
      wrapper.classList.remove('input-disabled')
      input.disabled = false
    }
  })
  ;[...document.querySelectorAll('[data-name=GroupHierarchies]')].forEach(
    input => {
      const wrapper = input.closest('.checkbox-wrapper')

      if (checkedExcluded.includes(input.dataset.groupId)) {
        wrapper.classList.add('input-disabled')
        input.disabled = true
      } else {
        wrapper.classList.remove('input-disabled')
        input.disabled = false
      }
    }
  )

  document.querySelector('[data-name=Title]').value = news.Title
  document.querySelector('[data-name=Content]').value = news.Contents

  window.CKEDITOR.instances.ckcontent.setData(news.Contents)

  const unpublishDate = dayjs(news.Unpublish)
  const today = dayjs()
  const dateIn50Years = today.add(50, 'year')
  const unpublishDateIsAfter50Years = unpublishDate.isAfter(dateIn50Years)

  document.querySelector('[data-name=Created]').value = news.Created
  document.querySelector('[data-name=Unpublish]').value =
    unpublishDateIsAfter50Years ? '' : news.Unpublish

  let authorFound = false
  document.querySelectorAll('[data-name=Author]').forEach(e => {
    authorFound = e.value === news.Author
    e.selected = e.value === news.Author
  })

  if (!authorFound) {
    const select = document.querySelector('[data-name=Author]').parentElement
    const option = document.createElement('option')
    option.setAttribute('data-option-dummy', '')
    option.setAttribute('data-name', 'Author')
    option.value = news.Author
    option.textContent = news.Author
    option.selected = true
    select.appendChild(option)
  }

  document
    .querySelectorAll('[data-name=MustSign]')
    .forEach(e => (e.checked = news.MustSign.toString() === e.value))
  document
    .querySelectorAll('[data-name=CanInteract]')
    .forEach(e => (e.checked = news.CanInteract.toString() === e.value))
  document
    .querySelectorAll('[data-name=IsPush]')
    .forEach(e => (e.checked = news.IsPush.toString() === e.value))
  document
    .querySelectorAll('[data-name=IsEmail]')
    .forEach(e => (e.checked = news.IsEmail.toString() === e.value))
  document.querySelector('#btn-save-news').dataset.id = news.ID

  if (news.Images.length !== 0) {
    document.documentElement.style.setProperty(
      '--active-images',
      `'${news.Images.length}'`
    )
    document.querySelector('#btn-add-img').classList.add('active')
  }

  if (videos.length !== 0) {
    document.documentElement.style.setProperty(
      '--active-videos',
      `'${videos.length}'`
    )
    document.querySelector('#btn-add-video').classList.add('active')
  }

  if (links.length !== 0) {
    document.documentElement.style.setProperty(
      '--active-links',
      `'${links.length}'`
    )
    document.querySelector('#btn-add-link').classList.add('active')
  }

  if (Object.entries(poll).length !== 0) {
    document.documentElement.style.setProperty('--active-poll', "'1'")
    document.querySelector('#btn_add_poll').classList.add('active')
  }

  const recievers = document.querySelectorAll(
    '[data-name="GroupHierarchies"]:checked'
  )
  const excludedRecievers = document.querySelectorAll(
    '[data-name="ExcludedGroupHierarchies"]:checked'
  )

  const hierarchies = []

  ;[...recievers].concat([...excludedRecievers]).forEach(x => {
    const exists = hierarchies.some(y => y.groupID === x.dataset.groupId)
    const toBeExcluded = [...excludedRecievers].some(
      y => y.dataset.groupId === x.dataset.groupId
    )

    if (exists && toBeExcluded) {
      hierarchies.find(y => y.groupID === x.dataset.groupId).isExcluded = true
    } else {
      const g = new Group({
        groupID: x.dataset.groupId,
        groupName: x.dataset.groupName,
        canWrite: x.dataset.canWrite === 'true',
        parent: x.dataset.parent,
        hasChildren: x.dataset.hasChildren,
        lvl: x.dataset.lvl,
        isExcluded: [...excludedRecievers].includes(x)
      })

      hierarchies.push(g)
    }
  })

  window
    .fetch('/HR/api/countpostreceivers.aspx', {
      method: 'POST',
      body: JSON.stringify(hierarchies),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.text())
    .then(count => {
      const individualRecievers = document.querySelectorAll(
        '[data-name=IndividualRecievers]:checked'
      ).length
      const totalRecievers = Number(count) + individualRecievers

      setNewsRecievers(totalRecievers)
    })
    .catch(err => console.error(err))

  loadImages(news.Images)
  loadVideos(videos)
  loadLinks(links)
  loadPoll(poll)
}

const clearFields = () => {
  const groups = document.querySelectorAll('[data-name=Groups]')
  const groupHierarchies = document.querySelectorAll(
    '[data-name=GroupHierarchies]'
  )
  const excludedGroupHierarchies = document.querySelectorAll(
    '[data-name=ExcludedGroupHierarchies]'
  )

  document.querySelector('[data-name=Title]').value = ''
  document.querySelector('[data-name=Content]').value = ''

  // if (IS_DESKTOP) {
  window.CKEDITOR.instances.ckcontent.setData('')
  // }

  document.querySelector('[data-name=Created]').value = setDateTime()
  document.querySelector('[data-name=Unpublish]').value = ''
  document.querySelectorAll('[data-name=Author]').forEach((e, i) => {
    if (e.dataset.optionDummy !== undefined) {
      e.remove()
    }
    e.selected = i === 0
  })
  document
    .querySelectorAll('[data-name=CanInteract]')
    .forEach(i => (i.checked = i.value === 'true'))
  document
    .querySelectorAll('[data-name=IsPush]')
    .forEach(i => (i.checked = i.value === 'true'))
  document
    .querySelectorAll('[data-name=IsEmail]')
    .forEach(i => (i.checked = i.value === 'false'))
  document.querySelectorAll('[data-name=MustSign]')[1].checked = true
  ;[...groups].forEach(x => {
    x.checked = false
    x.parentElement.parentNode.style.display = 'block'
  })
  ;[...groupHierarchies].forEach(x => {
    const wrapper = x.closest('.checkbox-wrapper')
    x.checked = false
    x.dataset.parent === '0'
      ? wrapper.classList.remove('hidden')
      : wrapper.classList.add('hidden')
  })
  ;[...excludedGroupHierarchies].forEach(x => {
    const wrapper = x.closest('.checkbox-wrapper')
    x.checked = false
    x.dataset.parent === '0'
      ? wrapper.classList.remove('hidden')
      : wrapper.classList.add('hidden')
  })

  setSelectedGroupText()
  setSelectedIndividualRecipients()
  setSelectedGroupText(true)

  const recievers = document.querySelector('#number-of-recievers')
  setNewsRecievers(0)

  document.querySelector('.select-groups.select').textContent = lang_select
  document.querySelector('.select-individual-recipients.select').textContent =
    lang_select
  document.querySelector('.modal-images .files-container').innerHTML = ''
  document.querySelector('.modal-video .video-list').innerHTML = ''
  document.querySelector('.modal-links .link-list').innerHTML = ''
  document.querySelector('#btn-add-img').classList.remove('active')
  document.querySelector('#btn-add-video').classList.remove('active')
  document.querySelector('#btn-add-link').classList.remove('active')
  document.querySelector('#error-box-news').classList.remove('active')
  recievers.textContent = `0 ${lang_recipient}`
  recievers.dataset.value = 0
  document.querySelector('#btn-create-news .text').textContent =
    lang_create_news

  if (document.querySelector('#btn_add_poll') !== null) {
    clearPoll()
  }
}

const loadImages = imgArr => {
  const filesContainer = document.querySelector('.files-container')

  for (let i = 0; i < imgArr.length; i++) {
    const item = document.createElement('div')
    item.className = 'item'

    const btnClose = document.createElement('div')
    const closeIcon = document.createElement('i')
    btnClose.className = 'btn-close'
    closeIcon.className = 'fas fa-times'
    btnClose.appendChild(closeIcon)

    const img = document.createElement('img')
    img.dataset.name = 'Images'
    img.dataset.extension = imgArr[i].Extension
    img.dataset.deleted = false
    img.src = `/FILEARCHIVE/${imgArr[i].Src}`
    img.dataset.id = imgArr[i].ID

    img.addEventListener('click', () => {
      createImgModal(img)
      Core.UnlockViewport()
    })

    btnClose.addEventListener('click', () => {
      img.dataset.deleted = true
      item.style.display = 'none'
      Core.LockViewport()
    })

    item.appendChild(btnClose)
    item.appendChild(img)
    filesContainer.appendChild(item)
  }
}

const loadVideos = videoArr => {
  const container = document.querySelector('.modal-video .video-list')

  for (let i = 0; i < videoArr.length; i++) {
    const type = videoArr[i].Type
    const URL = videoArr[i].URL

    const item = document.createElement('div')
    item.className = 'single-video-element'
    item.dataset.payload = 'true'
    item.dataset.deleted = 'false'
    item.dataset.name = 'Video'

    item.innerHTML = `
      <div class='left'>
        <div class='select'>
          <select class='video-type'>
            <option value='YouTube'>YouTube</option>
            <!-- <option value='Vimeo'>Vimeo</option> -->
          </select>
        </div>
        <input type='text' data-type='${type}' value='${URL}' placeholder='URL'>
      </div>
      <div class='right'>
        <i class='fas fa-times'></i>
      </div>
    `

    item.querySelectorAll('option').forEach(x => {
      if (x.value === type) {
        x.selected = true
      }
    })

    item.querySelector('.fas.fa-times').addEventListener('click', () => {
      item.dataset.deleted = 'true'
      item.style.display = 'none'
    })

    container.appendChild(item)
  }
}

/**
 *
 * @param {Poll} poll
 * @returns
 */
const loadPoll = poll => {
  if (Object.entries(poll).length === 0) {
    return
  }

  const modal = document.querySelector('.modal-poll')
  const answerList = modal.querySelector('.poll-answer-list')

  modal.querySelector('[data-id="poll__question"]').textContent = poll.question
  poll.answers.forEach(answer => createPollAnswerElement(answerList, answer))
  modal.querySelector('[data-id="poll__end-date"]').value = setDateTime(
    false,
    poll.endDate
  )
  ;[...modal.querySelectorAll('[data-id="poll__setting-visible"]')].filter(
    x => x.value === poll.visible
  )[0].checked = true
  const pollEndedElement = [...modal.querySelectorAll('[data-id="poll__setting-visible--poll-ended"]')].find(x => x.value === poll.visiblePollEnded)

  if (pollEndedElement) {
    pollEndedElement.checked = true
  }
  ;[...modal.querySelectorAll('[data-id="poll__setting-multiple"]')].filter(
    x => x.value === poll.multipleAnswers
  )[0].checked = true
  modal.querySelector('[data-id="poll__remove"]').classList.remove('hidden')
  modal.querySelector('#poll__hidden').value = JSON.stringify(poll)
}

const loadLinks = linkArr => {
  const container = document.querySelector('.modal-links .link-list')

  for (let i = 0; i < linkArr.length; i++) {
    const name = linkArr[i].Name
    const URL = linkArr[i].URL

    const item = document.createElement('div')
    item.className = 'single-link-element'
    item.dataset.payload = 'true'
    item.dataset.deleted = 'false'
    item.dataset.name = 'Link'

    item.innerHTML = `
    <div class='left'>
      <input type='text' class='input-name' value='${name}' placeholder='${lang_link_name}'>
      <input type='text' class='input-url' value='${URL}' placeholder='URL'>
    </div>
    <div class='right'>
      <i class='fas fa-times'></i>
    </div>
  `

    item.querySelector('.fas.fa-times').addEventListener('click', () => {
      item.dataset.deleted = 'true'
      item.style.display = 'none'
    })

    container.appendChild(item)
  }
}

const clearPoll = () => {
  const modal = document.querySelector('.modal-poll')
  const hiddenField = modal.querySelector('#poll__hidden')

  modal.querySelector('[data-id="poll__question"]').value = ''
  modal.querySelectorAll('.single-poll-answer-element').forEach(x => x.remove())
  modal
    .querySelectorAll('input[data-id^="poll__setting"]')
    .forEach(x => (x.checked = false))
  modal.querySelectorAll('[data-id$="--error"]').forEach(x => {
    x.textContent = ''
    x.dataset.valid = 'false'
  })
  modal.querySelector('[data-id="poll__end-date"]').value = ''
  modal.querySelector('[data-id="poll__remove"]').classList.add('hidden')
  modal.querySelector('[data-id="poll__create"]').classList.remove('active')
  document.querySelector('#btn_add_poll').classList.remove('active')

  hiddenField.value = '{}'
}

export const editNews = newsID => {
  const createNewsWrapper = document.querySelector('.create-news-wrapper')
  const createPostBtn = document.querySelector('#btn-create-post')
  const createNewsBtn = document.querySelector('#btn-create-news')
  const create = createPostBtn.querySelector('.create-post')
  const edit = createPostBtn.querySelector('.edit-post')
  const save = createNewsWrapper.querySelector('#btn-save-news')

  create.classList.remove('active')
  edit.classList.add('active')
  save.classList.add('active')
  save.classList.remove('hidden')
  createNewsBtn.classList.add('hidden')
  createPostBtn.click()

  const news = new News(PAYLOAD.filter(x => x.ID === newsID)[0])

  setFields(news)
  setSelectedGroupText()
  setSelectedIndividualRecipients()
  setSelectedGroupText(true)
}

export const unpublishNews = newsID => {
  const news = new News(PAYLOAD.filter(x => x.ID === newsID)[0])

  news.Unpublish = dayjs().subtract(10, 'minutes').format()

  window
    .fetch(`/HR/api/createnews.aspx?id=${newsID}&delete=1`, {
      method: 'POST',
      body: JSON.stringify(news),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(res => {
      if (res.status === 200) {
        const typeofFeed =
          document.querySelector('[data-feed][data-active="true"]')?.dataset
            .feed || 'news'

        if (typeofFeed === 'socialWall') {
          reloadWithQueryString('feed=social-wall')
        } else {
          window.location.reload()
        }
      }
    })
    .catch(err => console.error(err))
}

const setupImages = () => {
  const btnAddImages = document.querySelector('#btn-add-img')
  const modal = document.querySelector('.modal-images')
  const btnClose = modal.querySelectorAll('.btn-close-modal')
  const inputImages = modal.querySelector('#file-images')
  const btnClearImgs = modal.querySelector('#btn-clear-imgs')
  const btnSave = document.querySelector('#btn-set-active-images')

  modal.addEventListener('click', e => {
    if ([...btnClose].filter(el => el.contains(e.target)).length !== 0) {
      modal.classList.remove('open')
      document.documentElement.classList.remove('no-scroll')
      home.classList.remove('no-scroll')
    }
  })

  btnAddImages.addEventListener('click', () => {
    modal.classList.add('open')
    document.documentElement.classList.add('no-scroll')
    home.classList.add('no-scroll')
  })

  inputImages.addEventListener(
    'change',
    () => {
      handleFileUpload(inputImages)
    },
    false
  )

  btnClearImgs.addEventListener('click', () => {
    const items = [...modal.querySelectorAll('.item')]

    items.forEach(i => {
      const img = i.querySelector('img')

      if (img.dataset.deleted === 'true') {
        img.dataset.deleted = 'false'
        i.style.display = 'flex'
      } else if (img.dataset.id === '0') {
        i.remove()
      }
    })

    document.documentElement.style.setProperty(
      '--active-images',
      `'${items.length}'`
    )

    if (items.length === 0) {
      document.querySelector('#btn-add-img').classList.remove('active')
    }
  })

  btnSave.addEventListener('click', () => {
    const imgs = [...modal.querySelectorAll('.files-container img')].filter(
      x => x.dataset.deleted === 'false'
    )

    imgs.length === 0
      ? document.querySelector('#btn-add-img').classList.remove('active')
      : document.querySelector('#btn-add-img').classList.add('active')

    document.documentElement.style.setProperty(
      '--active-images',
      `'${imgs.length}'`
    )
  })
}

const setupVideo = () => {
  const btnAddVideos = document.querySelector('#btn-add-video')
  const modal = document.querySelector('.modal-video')
  const btnAdd = modal.querySelector('.btn-add-video')
  const btnClose = modal.querySelector('.btn-close-modal')
  const list = modal.querySelector('.video-list')
  const btnSave = modal.querySelector('#btn-set-active-videos')

  btnSave.addEventListener('click', () => {
    modal.classList.add('open')
    document.documentElement.classList.add('no-scroll')
  })

  modal.addEventListener('click', e => {
    if (btnClose.contains(e.target)) {
      modal.classList.remove('open')
      document.documentElement.classList.remove('no-scroll')
      home.classList.remove('no-scroll')
    }
  })

  btnAddVideos.addEventListener('click', () => {
    modal.classList.add('open')
    document.documentElement.classList.add('no-scroll')
    home.classList.add('no-scroll')
  })

  btnAdd.addEventListener('click', () => {
    createVideoElement(list)
  })

  btnSave.addEventListener('click', () => {
    modal.querySelectorAll('.single-video-element').forEach(x => {
      const type = x.querySelector('option:checked').value

      x.querySelector('input[type=text]').dataset.type = type

      if (x.dataset.deleted === 'true') {
        x.remove()
      }
    })

    const videos = modal.querySelectorAll('.single-video-element')

    let invalidItems = 0

    videos.forEach(el => {
      const input = el.querySelector('input[type=text]')

      if (input.value === '') {
        input.classList.add('invalid')
        invalidItems++
      } else {
        input.classList.remove('invalid')
      }
    })

    if (invalidItems === 0) {
      videos.length === 0
        ? document.querySelector('#btn-add-video').classList.remove('active')
        : document.querySelector('#btn-add-video').classList.add('active')

      document.documentElement.style.setProperty(
        '--active-videos',
        `'${videos.length}'`
      )

      modal.classList.remove('open')
      document.documentElement.classList.remove('no-scroll')
      home.classList.remove('no-scroll')
    }
  })

  btnClose.addEventListener('click', () => {
    const items = modal.querySelectorAll('.single-video-element')

    items.forEach(x => {
      const type = x.querySelector('input[type=text]').dataset.type
      x.querySelectorAll('option').forEach(o => (o.selected = o.value === type))

      if (x.dataset.deleted === 'true') {
        x.dataset.deleted = 'false'
        x.style.display = 'grid'
      } else if (x.dataset.payload !== 'true') {
        x.remove()
      }
    })

    document.documentElement.style.setProperty(
      '--active-videos',
      `'${items.length}'`
    )

    if (items.length === 0) {
      document.querySelector('#btn-add-img').classList.remove('active')
    }
  })
}

const setupLinks = () => {
  const btnAddLink = document.querySelector('#btn-add-link')
  const modal = document.querySelector('.modal-links')
  const btnAdd = modal.querySelector('.btn-add-link')
  const btnClose = modal.querySelector('.btn-close-modal')
  const list = modal.querySelector('.link-list')
  const btnSave = modal.querySelector('#btn-set-active-links')

  btnSave.addEventListener('click', () => {
    modal.classList.add('open')
    document.documentElement.classList.add('no-scroll')
    home.classList.add('no-scroll')
  })

  modal.addEventListener('click', e => {
    if (btnClose.contains(e.target)) {
      modal.classList.remove('open')
      document.documentElement.classList.remove('no-scroll')
      home.classList.remove('no-scroll')
    }
  })

  btnAddLink.addEventListener('click', () => {
    modal.classList.add('open')
    document.documentElement.classList.add('no-scroll')
    home.classList.add('no-scroll')
  })

  btnAdd.addEventListener('click', () => {
    createLinkElement(list)
  })

  btnSave.addEventListener('click', () => {
    modal.querySelectorAll('.single-link-element').forEach(x => {
      if (x.dataset.deleted === 'true') {
        x.remove()
      }
    })

    const links = modal.querySelectorAll('.single-link-element')

    let invalidItems = 0

    links.forEach(el => {
      const name = el.querySelector('.input-name')
      const URL = el.querySelector('.input-url')

      if (name.value === '' || URL.value === '') {
        invalidItems++
      }

      name.value === ''
        ? name.classList.add('invalid')
        : name.classList.remove('invalid')
      URL.value === ''
        ? URL.classList.add('invalid')
        : URL.classList.remove('invalid')
    })

    if (invalidItems === 0) {
      links.length === 0
        ? document.querySelector('#btn-add-link').classList.remove('active')
        : document.querySelector('#btn-add-link').classList.add('active')

      document.documentElement.style.setProperty(
        '--active-links',
        `'${links.length}'`
      )

      modal.classList.remove('open')
      document.documentElement.classList.remove('no-scroll')
      home.classList.remove('no-scroll')
    }
  })

  btnClose.addEventListener('click', () => {
    const items = modal.querySelectorAll('.single-link-element')

    items.forEach(x => {
      if (x.dataset.deleted === 'true') {
        x.dataset.deleted = 'false'
        x.style.display = 'grid'
      } else if (x.dataset.payload !== 'true') {
        x.remove()
      }
    })

    document.documentElement.style.setProperty(
      '--active-links',
      `'${items.length}'`
    )

    if (items.length === 0) {
      document.querySelector('#btn-add-link').classList.remove('active')
    }
  })
}

const setupPoll = () => {
  const modal = document.querySelector('.modal-poll')
  const btnClose = modal.querySelector('.btn-close-modal')
  const btnAddPoll = document.querySelector('#btn_add_poll')
  const btnRmvPoll = modal.querySelector('[data-id="poll__remove"]')
  const btnAddAnswer = modal.querySelector('.btn-add-answer')
  const btnCreatePoll = modal.querySelector('[data-id="poll__create"]')
  const list = modal.querySelector('.poll-answer-list')
  const hiddenField = modal.querySelector('#poll__hidden')

  btnAddPoll?.addEventListener('click', () => {
    modal.classList.add('open')
    document.documentElement.classList.add('no-scroll')
    home.classList.add('no-scroll')

    if (btnAddPoll.classList.contains('active')) {
      pollIsValid(btnCreatePoll)
    }
  })

  modal.addEventListener('click', e => {
    if (btnClose.contains(e.target)) {
      modal.classList.remove('open')
      document.documentElement.classList.remove('no-scroll')
      home.classList.remove('no-scroll')
    }
  })

  btnAddAnswer.addEventListener('click', () => {
    createPollAnswerElement(list)
    btnCreatePoll.classList.remove('active')
  })

  btnCreatePoll.addEventListener('click', () => {
    if (pollIsValid(btnCreatePoll)) {
      createPoll()

      hiddenField.dataset.delete = false
      btnAddPoll.classList.add('active')
      document.documentElement.style.setProperty('--active-poll', "'1'")
      modal.classList.remove('open')
      document.documentElement.classList.remove('no-scroll')
      home.classList.remove('no-scroll')
      btnRmvPoll.classList.remove('hidden')
    } else {
      btnCreatePoll.classList.remove('active')
      btnAddPoll.classList.remove('active')
    }
  })

  btnRmvPoll.addEventListener('click', () => {
    hiddenField.dataset.delete = true
    modal.classList.remove('open')
    document.documentElement.classList.remove('no-scroll')
    home.classList.remove('no-scroll')
    clearPoll()
  })

  modal.querySelectorAll('input[type=text], textarea').forEach(i => {
    i.addEventListener('input', () => pollIsValidWithOrigin(btnCreatePoll, i))
  })

  modal.querySelectorAll('input[type=radio]').forEach(i => {
    i.addEventListener('change', () => pollIsValidWithOrigin(btnCreatePoll, i))
  })

  modal.querySelectorAll('input[type=datetime-local]').forEach(i => {
    i.addEventListener('change', () => pollIsValidWithOrigin(btnCreatePoll, i))
  })
}

const createPoll = () => {
  const modal = document.querySelector('.modal-poll')
  const hiddenField = modal.querySelector('#poll__hidden')

  const question = modal.querySelector('[data-id="poll__question"]').value
  const answers = [...modal.querySelectorAll('[data-id="poll__answer"]')].map(
    x => x.value
  )
  const endDate = dayjs(modal.querySelector('[data-id="poll__end-date"]').value)
  const visible =
    modal.querySelector('[data-id="poll__setting-visible"]:checked').value ===
    'true'
  const visiblePollEnded =
    modal.querySelector('[data-id="poll__setting-visible--poll-ended"]:checked')
      .value === 'true'
  const multipleAnswers =
    modal.querySelector('[data-id="poll__setting-multiple"]:checked').value ===
    'true'

  const poll = {
    question,
    answers,
    endDate: endDate.format(),
    visible: visible.toString(),
    visiblePollEnded: visiblePollEnded.toString(),
    multipleAnswers: multipleAnswers.toString()
  }

  hiddenField.value = JSON.stringify(poll)
  hiddenField.dispatchEvent(new window.Event('change'))
}

const pollIsValidWithOrigin = (btn, origin) => {
  const modal = document.querySelector('.modal-poll')

  let errorElement = modal.querySelector(
    `[data-id="${origin.dataset.id}--error"]`
  )
  const tag = origin.tagName.toLowerCase()

  if (tag === 'textarea') {
    if (origin.value.length >= 3) {
      errorElement.textContent = ''
      errorElement.dataset.valid = 'true'
    } else {
      errorElement.dataset.valid = 'false'
    }
  }

  if (tag === 'input') {
    if (origin.type === 'text') {
      const all = document.querySelectorAll(`[data-id="${origin.dataset.id}"]`)

      if (all.length >= 2 && [...all].every(i => i.value !== '')) {
        errorElement.textContent = ''
        errorElement.dataset.valid = 'true'
      } else {
        errorElement.dataset.valid = 'false'
      }
    } else if (origin.type === 'radio') {
      errorElement.textContent = ''
      errorElement.dataset.valid = 'true'
    } else if (origin.type === 'datetime-local') {
      const date = dayjs(origin.value)

      if (date.isValid() && date.isAfter(dayjs())) {
        errorElement.textContent = ''
        errorElement.dataset.valid = 'true'
      } else {
        errorElement.dataset.valid = 'false'
      }
    }
  }

  if (tag === 'i') {
    const answers = modal.querySelectorAll('[data-id="poll__answer"]')
    errorElement = modal.querySelector('[data-id="poll__answer--error"]')

    if (answers.length < 2) {
      errorElement.textContent = lang_at_least_two_options
      errorElement.dataset.valid = 'false'
    }
  }

  const errorEls = [...modal.querySelectorAll('[data-id$="--error"]')]

  errorEls.forEach(p => {
    p.dataset.valid = p.textContent === '' ? 'true' : 'false'
  })

  const valid =
    [...errorEls].filter(p => p.dataset.valid === 'false').length === 0

  if (valid) {
    btn.classList.add('active')
  } else {
    btn.classList.remove('active')

    const hiddenField = modal.querySelector('#poll__hidden')

    if (hiddenField.value !== '{}') {
      hiddenField.value = '{}'
      hiddenField.dispatchEvent(new window.Event('change'))
    }
  }
}

const pollIsValid = btn => {
  const modal = document.querySelector('.modal-poll')

  const question = modal.querySelector('[data-id="poll__question"]')
  const answers = modal.querySelectorAll('[data-id="poll__answer"]')
  const endDate = modal.querySelector('[data-id="poll__end-date"]')
  const endDateValue = dayjs(endDate.value)
  const endDateErrorElement = modal.querySelector(
    `[data-id="${endDate.dataset.id}--error"]`
  )
  let settings = modal.querySelectorAll('input[data-id^="poll__setting"]')

  settings = [...settings].filter((input, index) => {
    return index === [...settings].findIndex(other => input.name === other.name)
  })

  modal.querySelector(`[data-id="${question.dataset.id}--error"]`).textContent =
    question.value.length < 3 ? lang_question_min_length : ''
  modal.querySelector('[data-id="poll__answer--error"]').textContent =
    answers.length < 2 ? lang_at_least_two_options : ''

  if (answers.length >= 2) {
    ;[...answers].every(input => {
      const errorElement = modal.querySelector(
        '[data-id="poll__answer--error"]'
      )

      if (input.value === '') {
        errorElement.textContent = lang_options_not_empty

        return false
      }

      errorElement.textContent = ''

      return true
    })
  }

  settings.forEach(input => {
    const inputs = modal.querySelectorAll(`[name="${input.name}"]`)
    const errorElement = modal.querySelector(
      `[data-id="${input.dataset.id}--error"]`
    )

    const checked = [...inputs].filter(i => i.checked).length === 1

    errorElement.textContent = checked ? '' : lang_option_must_be_selected
  })

  if (!endDateValue.isValid()) {
    endDateErrorElement.textContent = lang_must_have_end_date
  } else if (endDateValue.isBefore(dayjs())) {
    endDateErrorElement.textContent = lang_date_not_earlier_than_today
  } else {
    endDateErrorElement.textContent = ''
  }

  const errorEls = [...modal.querySelectorAll('[data-id$="--error"]')]

  errorEls.forEach(p => {
    p.dataset.valid = p.textContent === '' ? 'true' : 'false'
  })

  const valid =
    [...errorEls].filter(p => p.dataset.valid === 'false').length === 0

  if (valid) {
    btn.classList.add('active')
  } else {
    const hiddenField = modal.querySelector('#poll__hidden')

    if (hiddenField.value !== '{}') {
      hiddenField.value = '{}'
      hiddenField.dispatchEvent(new window.Event('change'))
    }
  }

  return valid
}

const createPollAnswerElement = (list, value = '') => {
  const btnCreate = document.querySelector('[data-id="poll__create"]')

  const wrap = document.createElement('div')
  wrap.className = 'single-poll-answer-element'

  const left = document.createElement('div')
  left.className = 'left'

  const right = document.createElement('div')
  right.className = 'right'

  const answer = document.createElement('input')
  answer.type = 'text'
  answer.placeholder = lang_answer_options
  answer.dataset.id = 'poll__answer'
  answer.value = value

  answer.addEventListener('input', () =>
    pollIsValidWithOrigin(btnCreate, answer)
  )

  left.appendChild(answer)

  const rmv = document.createElement('i')
  rmv.className = 'fas fa-times'

  right.appendChild(rmv)

  wrap.appendChild(left)
  wrap.appendChild(right)

  list.appendChild(wrap)

  rmv.addEventListener('click', () => {
    wrap.remove()

    pollIsValidWithOrigin(btnCreate, rmv)
  })
}

const createVideoElement = list => {
  const wrap = document.createElement('div')
  wrap.className = 'single-video-element'
  wrap.dataset.deleted = 'false'
  wrap.dataset.name = 'Video'

  const left = document.createElement('div')
  left.className = 'left'

  const right = document.createElement('div')
  right.className = 'right'

  const selectDiv = document.createElement('div')
  selectDiv.className = 'select'

  const select = document.createElement('select')
  select.className = 'video-type'

  const yt = document.createElement('option')
  yt.selected = true
  yt.value = 'YouTube'
  yt.textContent = 'YouTube'

  // const vimeo = document.createElement('option')
  // vimeo.value = 'Vimeo'
  // vimeo.textContent = 'Vimeo'

  select.appendChild(yt)
  // select.appendChild(vimeo)
  selectDiv.appendChild(select)
  left.appendChild(selectDiv)

  const input = document.createElement('input')
  input.type = 'text'
  input.dataset.type = 'YouTube'
  input.placeholder = 'URL'

  left.appendChild(input)

  const rmv = document.createElement('i')
  rmv.className = 'fas fa-times'

  right.appendChild(rmv)

  wrap.appendChild(left)
  wrap.appendChild(right)

  list.appendChild(wrap)

  select.addEventListener('change', e => {
    input.dataset.type = e.target.value
  })

  rmv.addEventListener('click', () => {
    wrap.remove()
  })
}

const createLinkElement = list => {
  const wrap = document.createElement('div')
  wrap.className = 'single-link-element'
  wrap.dataset.deleted = 'false'
  wrap.dataset.name = 'Link'

  const left = document.createElement('div')
  left.className = 'left'

  const right = document.createElement('div')
  right.className = 'right'

  const name = document.createElement('input')
  name.type = 'text'
  name.placeholder = lang_link_name
  name.className = 'input-name'

  const URL = document.createElement('input')
  URL.type = 'text'
  URL.placeholder = 'URL'
  URL.className = 'input-url'

  left.appendChild(name)
  left.appendChild(URL)

  const rmv = document.createElement('i')
  rmv.className = 'fas fa-times'

  right.appendChild(rmv)

  wrap.appendChild(left)
  wrap.appendChild(right)

  list.appendChild(wrap)

  rmv.addEventListener('click', () => {
    wrap.remove()
  })
}

const setupGroups = payload => {
  const config = {
    inputName: 'group-hierarchies',
    inputDataName: 'GroupHierarchies',
    btnBackId: 'btn-back-one-level',
    breadcrumbId: 'group-breadcrumb',
    selectClass: 'select-groups.select',
    modalClass: 'modal-group-hierarchies'
  }

  const targetWrapper = document.querySelector(`#${config.inputName}`)
  let allGroups = payload.map(x => new Group(x))

  const canOnlyUseSocialWall =
    allGroups.every(group => !group.canWrite) && !USER.Admin && useSocialWall

  if (canOnlyUseSocialWall) {
    document
      .querySelector('#btn-create-post')
      .setAttribute('style', 'display: none')
  }

  // Memo/cache to avoid re-checking the same group repeatedly
  const visitedCache = {}

  function hasUserInSelfOrChildren (groupId, groups, users) {
    // If we’ve already computed the value, return it
    if (visitedCache[groupId] !== undefined) {
      return visitedCache[groupId]
    }

    // 1. If this group is used by any user
    if (users.some(user => user.Roles.includes(groupId))) {
      visitedCache[groupId] = true
      return true
    }

    // 2. Otherwise, check descendants
    const children = groups.filter(g => g.parent === groupId)
    for (const child of children) {
      if (hasUserInSelfOrChildren(child.groupID, groups, users)) {
        visitedCache[groupId] = true
        return true
      }
    }

    // If neither this group nor its descendants have any user referencing them
    visitedCache[groupId] = false
    return false
  }

  // Then filter:
  allGroups = allGroups.filter(group =>
    hasUserInSelfOrChildren(group.groupID, allGroups, USERS)
  )

  // Add group checkboxes to the target wrapper
  allGroups.forEach(group => {
    if (group.groupName.toLowerCase() === 'system') {
      return
    }

    const checkboxWrapper = createCheckboxWrapper(
      group,
      config.inputName,
      config.inputDataName,
      config.btnBackId,
      config.breadcrumbId
    )
    targetWrapper.appendChild(checkboxWrapper)
  })

  setupBackBtn(config.btnBackId, config.breadcrumbId, config.inputDataName)
  setupSelectGroups(config.selectClass, config.modalClass)
}

const setupSelectGroups = (selectClass, modalClass) => {
  const btnSelectGroups = document.querySelector(`.${selectClass}`)
  btnSelectGroups.textContent = lang_select

  const modal = document.querySelector(`.${modalClass}`)
  const inner = modal.querySelector('.inner')
  const btnClose = modal.querySelectorAll('.btn-close-modal')

  modal.addEventListener('click', e => {
    if (
      !inner.contains(e.target) ||
      [...btnClose].filter(el => el.contains(e.target)).length !== 0
    ) {
      modal.classList.remove('open')
      document.documentElement.classList.remove('no-scroll')
    }
  })

  btnSelectGroups.addEventListener('click', () => {
    document.documentElement.classList.add('no-scroll')
    home.classList.remove('no-scroll')

    modal.classList.add('open')

    if (useSocialWall) {
      filterGroups()
    }
  })
}

function setupIndividualRecipients () {
  const dataName = 'IndividualRecipients'
  const selectClass = 'select-individual-recipients.select'
  const modalClass = 'modal-individual-recipients'

  const targetWrapper = document.querySelector('#individual-recipients')

  const modal = document.querySelector(`.${modalClass}`)
  const inner = modal.querySelector('.inner')
  const loading = modal.querySelector('.loading')
  const btnClose = modal.querySelectorAll('.btn-close-modal')

  modal.addEventListener('click', e => {
    if (
      !inner.contains(e.target) ||
      [...btnClose].filter(el => el.contains(e.target)).length !== 0
    ) {
      modal.classList.remove('open')
      document.documentElement.classList.remove('no-scroll')
    }
  })

  const btnSelectGroups = document.querySelector(`.${selectClass}`)
  btnSelectGroups.textContent = lang_select

  btnSelectGroups.addEventListener('click', async () => {
    document.documentElement.classList.add('no-scroll')
    home.classList.remove('no-scroll')

    modal.classList.add('open')

    USERS.forEach(user => {
      const name = `${user.Fornamn} ${user.Efternamn}`

      const checkboxWrapper = document.createElement('div')
      checkboxWrapper.className = 'user-checkbox-wrapper'

      const label = document.createElement('label')

      const textWrapper = document.createElement('p')

      const nameEl = document.createElement('span')
      nameEl.textContent = `${name} (${user.Email})`

      const groupEl = document.createElement('span')
      groupEl.textContent = user.RolesStr.sort().join(', ')

      const groupElIcon = document.createElement('i')
      groupElIcon.className = 'fas fa-user-friends'

      const input = document.createElement('input')
      input.type = 'checkbox'
      input.className = 'input-field'
      input.value = name
      input.dataset.userId = user.UserID
      input.dataset.name = dataName

      const span = document.createElement('span')

      groupEl.prepend(groupElIcon)
      textWrapper.append(nameEl, groupEl)
      label.append(input, span, textWrapper)
      checkboxWrapper.appendChild(label)

      targetWrapper.appendChild(checkboxWrapper)

      input.addEventListener('change', () => {
        const currentCount = document.querySelector('#number-of-recievers')
          .dataset.value
        let newCount = input.checked
          ? Number(currentCount) + 1
          : Number(currentCount) - 1

        newCount = newCount < 0 ? 0 : newCount

        setNewsRecievers(newCount)
      })
    })

    loading.classList.add('hidden')
    targetWrapper.classList.remove('hidden')
  })
}

function setupSearchIndividualRecipients () {
  const searchInput = document.querySelector(
    '#input-search-individual-recipients'
  )

  searchInput.addEventListener('input', e => {
    const searchVal = e.target.value.toLowerCase()
    const targets = document.querySelectorAll(
      '.modal-individual-recipients #individual-recipients .user-checkbox-wrapper'
    )

    targets.forEach(target => {
      if (searchVal === '') {
        target.classList.remove('hidden')
        return
      }

      target.classList.add('hidden')
      const allTextContent = getTextContent(target)

      if (allTextContent.toLowerCase().includes(searchVal)) {
        target.classList.remove('hidden')
      }
    })
  })
}

function getTextContent (node) {
  let textContent = ''

  function traverse (node) {
    if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '') {
      textContent += node.textContent.trim() + ' '
    } else {
      for (let i = 0; i < node.childNodes.length; i++) {
        traverse(node.childNodes[i])
      }
    }
  }

  traverse(node)
  return textContent.trim()
}

const setupExcludedGroups = payload => {
  const inputName = 'excluded-group-hierarchies'
  const inputDataName = 'ExcludedGroupHierarchies'
  const btnBackId = 'excluded-btn-back-one-level'
  const breadcrumbId = 'excluded-group-breadcrumb'
  const selectClass = 'select-excluded-groups.select'
  const modalClass = 'modal-excluded-group-hierarchies'

  const targetWrapper = document.querySelector('#excluded-group-hierarchies')
  const allGroups = payload.map(x => new Group(x))

  allGroups.forEach(g => {
    const cbWrapper = createCheckboxWrapper(
      g,
      inputName,
      inputDataName,
      btnBackId,
      breadcrumbId
    )
    targetWrapper.appendChild(cbWrapper)
  })

  setupBackBtn(btnBackId, breadcrumbId, inputDataName)
  setupSelectGroups(selectClass, modalClass)
}

const setupBackBtn = (btnBackId, breadcrumbId, inputDataName) => {
  const btn = document.querySelector(`#${btnBackId}`)

  btn.addEventListener('click', () => {
    btn.dataset.level--

    const allGroups = document.querySelectorAll(
      `[data-name="${inputDataName}"]`
    )

    allGroups.forEach(g => {
      const wrapper = g.closest('.checkbox-wrapper')

      g.dataset.level === btn.dataset.level
        ? wrapper.classList.remove('hidden')
        : wrapper.classList.add('hidden')
    })

    const breadcrumb = document.querySelector(`#${breadcrumbId}`)

    breadcrumb.dataset.previousValue = breadcrumb.textContent

    const lastIndex = breadcrumb.dataset.previousValue.lastIndexOf('>')
    breadcrumb.textContent = breadcrumb.dataset.previousValue.slice(
      0,
      lastIndex
    )
  })
}

/**
 *
 * @param {Array} groupHierarchies
 */
const setupSearchGroups = groupHierarchies => {
  const groups = document.querySelectorAll('[data-name="GroupHierarchies"]')
  const searchInput = document.querySelector('#input-search-group-hierarchies')
  const searchText = document.querySelector('#search-text-group-hierarchies')

  const orderedGroupArray = createHierarchialArray(groupHierarchies)

  searchInput.addEventListener('input', () => {
    const val = searchInput.value.toLowerCase()

    document.querySelector('#btn-back-one-level').dataset.level = 0
    document
      .querySelector('#search-text-group-hierarchies')
      .classList.add('hidden')

    if (val.length === 0) {
      searchText.classList.add('hidden')
      searchInput.classList.remove('active')

      groups.forEach(g => {
        const wrapper = g.closest('.checkbox-wrapper')
        g.dataset.hasChildren
          ? wrapper.classList.add('has-children')
          : wrapper.classList.remove('has-children')
        const p = g.parentNode.querySelector('p')

        g.dataset.parent === '0'
          ? wrapper.classList.remove('hidden')
          : wrapper.classList.add('hidden')
        p.textContent = g.dataset.groupName
      })

      return
    }

    searchText.classList.remove('hidden')
    searchInput.classList.add('active')

    groups.forEach(g => {
      const wrapper = g.closest('.checkbox-wrapper')
      wrapper.classList.add('hidden')
      wrapper.classList.remove('has-children')

      if (g.dataset.groupName.toLowerCase().includes(val)) {
        wrapper.classList.remove('hidden')
        const text = g.parentNode.querySelector('p')

        const ancestors = getAncestors(
          Number(g.dataset.groupId),
          orderedGroupArray
        )
        const strong = document.createElement('strong')
        strong.textContent =
          ancestors.length === 1
            ? ancestors[ancestors.length - 1]
            : ` > ${ancestors[ancestors.length - 1]}`

        text.textContent = `${lang_all} > ` + ancestors.slice(0, -1).join(' > ')
        text.appendChild(strong)
      }
    })
  })
}

const setupSearchExcludedGroups = groupHierarchies => {
  const groups = document.querySelectorAll(
    '[data-name="ExcludedGroupHierarchies"]'
  )
  const searchInput = document.querySelector(
    '#input-search-excluded-group-hierarchies'
  )
  const searchText = document.querySelector(
    '#search-text-excluded-group-hierarchies'
  )

  const orderedGroupArray = createHierarchialArray(groupHierarchies)

  searchInput.addEventListener('input', () => {
    const val = searchInput.value.toLowerCase()

    document.querySelector('#excluded-btn-back-one-level').dataset.level = 0
    document
      .querySelector('#search-text-excluded-group-hierarchies')
      .classList.add('hidden')

    if (val.length === 0) {
      searchText.classList.add('hidden')
      searchInput.classList.remove('active')

      groups.forEach(g => {
        const wrapper = g.closest('.checkbox-wrapper')
        g.dataset.hasChildren
          ? wrapper.classList.add('has-children')
          : wrapper.classList.remove('has-children')
        const p = g.parentNode.querySelector('p')

        g.dataset.parent === '0'
          ? wrapper.classList.remove('hidden')
          : wrapper.classList.add('hidden')
        p.textContent = g.dataset.groupName
      })

      return
    }

    searchText.classList.remove('hidden')
    searchInput.classList.add('active')

    groups.forEach(g => {
      const wrapper = g.closest('.checkbox-wrapper')
      wrapper.classList.add('hidden')
      wrapper.classList.remove('has-children')

      if (g.dataset.groupName.toLowerCase().includes(val)) {
        wrapper.classList.remove('hidden')
        const text = g.parentNode.querySelector('p')

        const ancestors = getAncestors(
          Number(g.dataset.groupId),
          orderedGroupArray
        )
        const strong = document.createElement('strong')
        strong.textContent =
          ancestors.length === 1
            ? ancestors[ancestors.length - 1]
            : ` > ${ancestors[ancestors.length - 1]}`

        text.textContent = `${lang_all} > ` + ancestors.slice(0, -1).join(' > ')
        text.appendChild(strong)
      }
    })
  })
}

const createHierarchialArray = groups => {
  const map = {}
  const roots = []
  let node

  for (let i = 0; i < groups.length; i++) {
    map[groups[i].groupID] = i
    groups[i].children = []
  }

  for (let i = 0; i < groups.length; i++) {
    node = groups[i]

    if (node.parent !== 0) {
      groups[map[node.parent]].children.push(node)
    } else {
      roots.push(node)
    }
  }

  return roots
}

const getAncestors = (target, children, ancestors = []) => {
  for (const node of children) {
    if (node.groupID === target) {
      return ancestors.concat(node.groupName)
    }

    const found = getAncestors(
      target,
      node.children,
      ancestors.concat(node.groupName)
    )

    if (found) {
      return found
    }
  }
  return undefined
}

const getAncestorElements = (target, children, elements = []) => {
  for (const node of children) {
    if (node.groupID === target) {
      return elements
    }

    const found = getAncestorElements(
      target,
      node.children,
      elements.concat(node)
    )

    if (found) {
      return found
    }
  }
  return undefined
}

/**
 *
 * @param {Group} group
 * @returns
 */
const createCheckboxWrapper = (
  group,
  inputName,
  inputDataName,
  backBtnId,
  breadcrumbId
) => {
  const cbWrapper = document.createElement('div')
  cbWrapper.className = 'checkbox-wrapper'

  if (group.parent !== 0) {
    cbWrapper.classList.add('hidden')
  }

  const label = document.createElement('label')

  const text = document.createElement('p')
  text.textContent = group.groupName

  const input = document.createElement('input')
  input.type = 'checkbox'
  input.className = 'input-field'
  input.name = inputName
  input.value = group.groupName
  input.disabled = group.canWrite === false
  input.dataset.name = inputDataName
  input.dataset.groupId = group.groupID
  input.dataset.groupName = group.groupName
  input.dataset.canWrite = group.canWrite
  input.dataset.parent = group.parent
  input.dataset.hasChildren = group.hasChildren
  input.dataset.level = group.parent === 0 ? 0 : -1
  input.dataset.lvl = group.lvl
  input.dataset.access_publicering = group.access_publicering
  input.dataset.access_mediearkiv = group.access_mediearkiv
  input.dataset.access_produktdatabas = group.access_produktdatabas
  input.dataset.access_mailutskick = group.access_mailutskick
  input.dataset.access_kontohantering = group.access_kontohantering
  input.dataset.access_installningar = group.access_installningar
  input.dataset.sort = group.sort

  const span = document.createElement('span')

  label.appendChild(input)
  label.appendChild(span)
  label.appendChild(text)

  cbWrapper.appendChild(label)

  if (group.canWrite === false) {
    cbWrapper.classList.add('disabled')
  }

  if (group.hasChildren === true) {
    cbWrapper.classList.add('has-children')

    const chevron = document.createElement('i')
    chevron.className = 'fa-solid fa-chevron-right chevron'

    chevron.addEventListener('click', () => {
      const backBtn = document.querySelector(`#${backBtnId}`)
      backBtn.dataset.level++

      const allGroups = document.querySelectorAll(
        `[data-name="${inputDataName}"]`
      )

      allGroups.forEach(g => {
        const wrapper = g.closest('.checkbox-wrapper')

        if (g.dataset.parent === group.groupID.toString()) {
          wrapper.classList.remove('hidden')
          g.dataset.level = backBtn.dataset.level
        } else {
          wrapper.classList.add('hidden')
        }
      })

      const breadcrumb = document.querySelector(`#${breadcrumbId}`)

      breadcrumb.dataset.previousValue = breadcrumb.textContent

      if (group.parent === 0) {
        breadcrumb.textContent = lang_all
      }

      breadcrumb.textContent += ` > ${group.groupName}`
    })

    cbWrapper.appendChild(chevron)
  }

  input.addEventListener('change', () => {
    const recievers = document.querySelectorAll(
      '[data-name="GroupHierarchies"]:checked'
    )
    const excludedRecievers = document.querySelectorAll(
      '[data-name="ExcludedGroupHierarchies"]:checked'
    )

    const hierarchies = []

    ;[...recievers].concat([...excludedRecievers]).forEach(x => {
      const exists = hierarchies.some(y => y.groupID === x.dataset.groupId)
      const toBeExcluded = [...excludedRecievers].some(
        y => y.dataset.groupId === x.dataset.groupId
      )

      if (exists && toBeExcluded) {
        hierarchies.find(y => y.groupID === x.dataset.groupId).isExcluded = true
      } else {
        const g = new Group({
          groupID: x.dataset.groupId,
          groupName: x.dataset.groupName,
          canWrite: x.dataset.canWrite === 'true',
          parent: x.dataset.parent,
          hasChildren: x.dataset.hasChildren,
          lvl: x.dataset.lvl,
          access_publicering: input.dataset.access_publicering,
          access_mediearkiv: input.dataset.access_mediearkiv,
          access_produktdatabas: input.dataset.access_produktdatabas,
          access_mailutskick: input.dataset.access_mailutskick,
          access_kontohantering: input.dataset.access_kontohantering,
          access_installningar: input.dataset.access_installningar,
          sort: input.dataset.sort,
          isExcluded: [...excludedRecievers].includes(x)
        })

        hierarchies.push(g)
      }
    })

    window
      .fetch('/HR/api/countpostreceivers.aspx', {
        method: 'POST',
        body: JSON.stringify(hierarchies),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(res => res.text())
      .then(count => {
        const individualRecipients = document.querySelectorAll(
          '[data-name=IndividualRecipients]:checked'
        ).length
        const totalRecievers = Number(count) + individualRecipients

        setNewsRecievers(totalRecievers)
      })
      .catch(err => console.error(err))
  })

  return cbWrapper
}

const setNewsRecievers = count => {
  const btnSave = document.querySelectorAll(
    '#btn-save-group-hierarchies, #btn-save-excluded-group-hierarchies, #btn-save-individual-recipients'
  )
  const recieverDiv = document.querySelector('#number-of-recievers')

  if (count === 0) {
    btnSave.forEach(btn => (btn.textContent = lang_select_recipient))
    recieverDiv.textContent = `0 ${lang_recipient}`
    recieverDiv.dataset.value = 0
  } else {
    btnSave.forEach(
      btn => (btn.textContent = `${lang_select_recipient} (${count})`)
    )
    recieverDiv.textContent = `${count} ${lang_recipient}`
    recieverDiv.dataset.value = count
    recieverDiv.classList.remove('hidden')
  }
}

const getUser = () => {
  USER = JSON.parse(document.querySelector('#user').value)
}

const setupSwiper = (isImgModal = false, activeSlide = 0) => {
  if (!isImgModal) {
    const sw = document.querySelectorAll('.swiper')

    for (let i = 0; i < sw.length; i++) {

      new Swiper(sw[i], {
        slidesPerView: 1.2,
        spaceBetween: 10
      })
    }
  } else {
    const sw = document.querySelector('.custom-modal .swiper')

    new Swiper(sw, {
      slidesPerView: 1.2,
      spaceBetween: 10,
      centeredSlides: true,
      on: {
        init: function () {
          this.slideTo(activeSlide, 0, false)
        }
      }
    })
  }
}

const setupModals = () => {
  const modalUnpublish = document.querySelector('.modal-unpublish')
  const btnBackUnpublish = modalUnpublish.querySelectorAll(
    '.button-back-top, .btn-close-modal'
  )
  const btnUnpublish = modalUnpublish.querySelector('#button-unpublish')

  btnBackUnpublish.forEach(btn => {
    btn.addEventListener('click', () => {
      document.documentElement.classList.remove('no-scroll')
      home.classList.remove('no-scroll')
      modalUnpublish.classList.remove('open')
    })
  })

  btnUnpublish.addEventListener('click', () => {
    document.documentElement.classList.remove('no-scroll')
    home.classList.remove('no-scroll')
    const newsID = Number(btnUnpublish.dataset.newsid)
    unpublishNews(newsID)
  })
}

/**
 *
 * @param {Poll} poll
 * @param {Array} uniqueVotes
 */
const setupPollStats = (poll, votes, newsItem, newsCreator) => {
  if (
    newsCreator !== USER.UserID &&
    (poll.visible === 'false' || votes.length === 0) &&
    poll?.visiblePollEnded === 'false'
  ) {
    return
  }

  const totalVotes = votes.length
  const uniqueAlternatives = [...new Set(votes)]

  uniqueAlternatives.forEach(alt => {
    const numItems = votes.filter(v => v === alt)
    const percentage = Math.round((numItems.length * 100) / totalVotes)

    const altEl = newsItem.querySelector(`.poll__answer[data-index="${alt}"]`)

    if (!altEl.classList.contains('poll__answer-active')) {
      altEl.classList.add('poll__answer-active--grey')
    }

    const span = document.createElement('span')
    span.textContent = `${percentage}%`
    span.className = 'poll__percentage'

    altEl.style.backgroundSize = `${percentage}%`

    altEl.appendChild(span)
  })

  const noneVotedAlts = newsItem.querySelectorAll(
    '.poll__answer:not(.poll__answer-active--grey):not(.poll__answer-active)'
  )

  noneVotedAlts.forEach(alt => {
    const span = document.createElement('span')
    span.textContent = '0%'
    span.className = 'poll__percentage'

    alt.appendChild(span)
    alt.style.backgroundSize = '0%'
  })

  if (newsCreator === USER.UserID && poll.visible === 'false') {
    const pollHasEnded = dayjs(poll.endDate).isBefore(dayjs())

    if (pollHasEnded && poll.visiblePollEnded === 'true') {
      return
    }

    const target = newsItem.querySelector('.poll__answer-wrapper')

    const info = document.createElement('p')
    info.className = 'poll__visibility-info'
    info.textContent = lang_result_only_visible_to_you

    target.insertAdjacentElement('afterend', info)
  }
}

const setupCKEditor = () => {
  document.querySelector('#ckcontent').parentNode.classList.add('is-editor')

  window.CKEDITOR.env.isCompatible = true

  const editor = window.CKEDITOR.replace('ckcontent', {
    language: 'en',
    toolbar: 'Full',
    height: 300,
    toolbar_Full: [
      [
        'Bold',
        'Underline',
        'Italic',
        '-',
        'AFT',
        '-',
        'NumberedList',
        'BulletedList',
        '-',
        'Link',
        'Unlink',
        '|',
        'Youtube'
      ]
    ],
    colorButton_colors: '654321,f00,ff00',
    uiColor: '#ffffff',
    contentsCss: ['/HR/css/ckeditor.min.css', '/HR/bootstrap/css/_bootstrap.min.css?v.0'],
    resize_enabled: false,
    extraPlugins: 'editorplaceholder,youtube,AFT',
    editorplaceholder: lang_what_to_talk_about_today,
    youtube_responsive: true,
    allowedContent: true,
    pasteFromWordRemoveFontStyles: false,
    pasteFromWordRemoveStyles: false
  })

  editor.on('instanceReady', function (event) {
    event.editor.on('paste', function (ev) {
      const temp = document.createElement('div')

      temp.innerHTML = ev.data.dataValue

      const allChildTags = temp.getElementsByTagName('*')

      for (let i = 0; i < allChildTags.length; i++) {
        const item = allChildTags.item(i)
        item.removeAttribute('style')
      }

      ev.data.dataValue = temp.innerHTML

      temp.remove()
    })
  })

  editor.config.iframe_attributes = {
    sandbox: 'allow-scripts allow-same-origin'
  }

  window.newsEditor = editor

  editor.on('change', function (e) {
    checkValidity()
  })
}

const setupPullToRefresh = () => {
  const ptr = PullToRefresh.init({
    mainElement: 'div.news-wrapper',
    triggerElement: 'div.news-wrapper',
    instructionsPullToRefresh: lang_pull_down_to_refresh,
    instructionsReleaseToRefresh: lang_release_to_refresh,
    instructionsRefreshing: lang_updating,
    iconArrow: '<img src="/admin/env6/env-icon.png">',
    iconRefreshing: '<img class="fa-spin" src="/admin/env6/env-icon.png">',
    distReload: 80,
    refreshTimeout: 700,
    onRefresh () {
      const typeofFeed =
        document.querySelector('[data-feed][data-active="true"]')?.dataset
          .feed || 'news'

      if (typeofFeed === 'socialWall') {
        reloadWithQueryString('feed=social-wall')
      }
    }
  })
}

const setupAi = () => {
  const btnAi = document.querySelector('#btn_ai')
  const modal = document.querySelector('.modal-ai')
  const btnClose = modal.querySelector('.btn-close-modal')
  const btnSave = modal.querySelector('[data-id="ai__btn-save"]')
  const commandBtns = modal.querySelectorAll('.modal-ai__cmd-btn[data-command]')
  const optBtns = modal.querySelectorAll('.modal-ai__cmd-btn--opt')

  btnAi.addEventListener('click', () => {
    modal.classList.add('open')
    document.documentElement.classList.add('no-scroll')
    home.classList.add('no-scroll')
  })

  modal.addEventListener('click', e => {
    if (btnClose.contains(e.target)) {
      modal.classList.remove('open')
      document.documentElement.classList.remove('no-scroll')
      home.classList.remove('no-scroll')
    }
  })

  btnSave.addEventListener('click', e => {
    if (e.target.dataset.clicked === 'true') {
      return
    }

    btnSave.dataset.clicked = 'true'

    const spinner = btnSave.querySelector('[data-id="spinner"]')
    const span = btnSave.querySelector('span')
    spinner.classList.remove('hidden')
    span.classList.add('hidden')

    const textarea = modal.querySelector('[data-id="ai__textarea"]')

    const body = {
      data: textarea.value.replace(/[\n\t]/g, ' ').replace(/\"/g, '"')
    }

    window
      .fetch('https://ai.envodium.se/custom/api/generatearticle.aspx', {
        method: 'POST',
        body: JSON.stringify(body)
      })
      .then(res => res.json())
      .then(data => {
        const answer = data?.choices[0]?.text

        window.newsEditor.setData(answer.replace(/\n/g, '<br>'))
        modal.classList.remove('open')
        document.documentElement.classList.remove('no-scroll')
        home.classList.remove('no-scroll')

        spinner.classList.add('hidden')
        span.classList.remove('hidden')
        btnSave.dataset.clicked = 'false'
      })
  })

  let oldValue = ''

  commandBtns.forEach(btn => {
    btn.addEventListener('click', e => {
      if (e.target.dataset.clicked === 'true') {
        return
      }

      btn.dataset.clicked = 'true'

      const spinner = btn.querySelector('[data-id="spinner"]')
      const span = btn.querySelector('span')
      spinner.classList.remove('hidden')
      span.classList.add('hidden')

      const textarea = modal.querySelector('[data-id="ai__textarea"]')
      oldValue = textarea.value

      const body = {
        data:
          btn.dataset.command +
          textarea.value.replace(/[\n\t]/g, ' ').replace(/\"/g, '"') +
          btn.dataset.commandSuffix
      }

      window
        .fetch('https://ai.envodium.se/custom/api/generatearticle.aspx', {
          method: 'POST',
          body: JSON.stringify(body)
        })
        .then(res => res.json())
        .then(data => {
          const answer = data?.choices[0]?.text

          textarea.value = answer.trim()

          spinner.classList.add('hidden')
          span.classList.remove('hidden')
          btnSave.dataset.clicked = 'false'

          btnSave.classList.add('hidden')
          commandBtns.forEach(btn => btn.classList.add('hidden'))
          optBtns.forEach(btn => btn.classList.remove('hidden'))
        })
    })
  })

  optBtns.forEach(btn => {
    const cmdUse = btn.dataset.id === 'ai__btn-use'
    const textarea = modal.querySelector('[data-id="ai__textarea"]')

    btn.addEventListener('click', () => {
      if (cmdUse) {
        window.newsEditor.setData(textarea.value.replace(/\n/g, '<br>'))
        modal.classList.remove('open')
        document.documentElement.classList.remove('no-scroll')
        home.classList.remove('no-scroll')
        textarea.value = ''
      } else {
        textarea.value = oldValue
      }

      btnSave.classList.remove('hidden')
      optBtns.forEach(btn => btn.classList.add('hidden'))
      commandBtns.forEach(btn => btn.classList.remove('hidden'))
    })
  })

  const btnExamples = modal.querySelector('.modal-ai__example-btn')
  const modalExample = document.querySelector('.modal-ai__example')
  const btnCloseExample = modalExample.querySelector('.btn-close-modal')

  btnExamples.addEventListener('click', () => {
    modalExample.classList.add('open')
  })

  modalExample.addEventListener('click', e => {
    if (btnCloseExample.contains(e.target)) {
      modalExample.classList.remove('open')
    }
  })

  modalExample.querySelectorAll('.modal-ai__single-example').forEach(ex => {
    ex.addEventListener('click', () => {
      modal.querySelector('[data-id="ai__textarea"]').value = ex.textContent
      modalExample.classList.remove('open')
    })
  })
}

/**
 *
 * @param {News} news
 */
function createHasSeen (news) {
  if (news.UserHasSeen === true) {
    return
  }

  const newsSeen = new NewsSeen()
  newsSeen.NewsRef = news.ID
  newsSeen.UserIDRef = USER.UserID
  newsSeen.UserName = `${USER.FirstName} ${USER.LastName}`
  newsSeen.TimeSeen = dayjs().format()

  window
    .fetch('/HR/api/createhasseen.aspx', {
      method: 'POST',
      body: JSON.stringify(newsSeen),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(res => {
      if (res.status === 200) {
        const newsInPayload = PAYLOAD.filter(x => x.ID === Number(news.ID))[0]
        const newsInList = document.querySelector(
          `.single-news[data-id='${news.ID}']`
        )

        newsInPayload.UserHasSeen = true
        news.UserHasSeen = true
        newsInList.dataset.hasSeen = 'true'
        newsInList.querySelector('.single-news-read').remove()
      }
    })
    .catch(err => console.error(err))
}

function filterGroups () {
  const searchGroups = document.querySelector('#input-search-group-hierarchies')
  const activeFeed = document.querySelector('[data-feed][data-active="true"]')
    .dataset.feed

  activeFeed === 'socialWall'
    ? searchGroups.classList.add('hidden')
    : searchGroups.classList.remove('hidden')

  const targetGroup = document.querySelector(
    `[data-name="GroupHierarchies"][data-group-id="${socialWallTargetGroup}"]`
  )
  const targetChildren = document.querySelectorAll(
    `[data-name="GroupHierarchies"][data-parent="${socialWallTargetGroup}"]`
  )

  if (activeFeed === 'socialWall' && targetGroup) {
    const wrapper = targetGroup.closest('.checkbox-wrapper')
    const chevron = wrapper.querySelector('.chevron')

    chevron?.click()

    const backBtn = document.querySelector(
      '.modal-group-hierarchies #btn-back-one-level'
    )
    backBtn.dataset.level = '0'

    searchGroups.classList.add('hidden')
  }

  targetChildren.forEach(el => {
    const wrapper = el.closest('.checkbox-wrapper')
    const chevron = wrapper.querySelector('.chevron')

    if (activeFeed === 'socialWall') {
      chevron?.classList.add('hidden')

      if (wrapper.classList.contains('disabled')) {
        wrapper.dataset.shouldBeDisabled = true
        wrapper.classList.remove('disabled')
        el.disabled = false
      }
    } else {
      if (wrapper.dataset.shouldBeDisabled) {
        wrapper.classList.add('disabled')
        el.disabled = true
      }

      chevron?.classList.remove('hidden')
    }
  })
}

function reloadWithQueryString (queryString) {
  const currentUrl = window.location.href
  const newUrl = currentUrl.includes('?')
    ? `${currentUrl}&${queryString}`
    : `${currentUrl}?${queryString}`

  window.location.href = newUrl
}

function init () {
  PAYLOAD = '[]'
  const urlParams = new window.URLSearchParams(window.location.search)
  const feed = urlParams.get('feed')
  const hierarchyUrl = useSocialWall
    ? '/HR/api/getgrouphierarchy.aspx?social-wall=true'
    : '/HR/api/getgrouphierarchy.aspx'

  window
    .fetch(hierarchyUrl)
    .then(res => res.json())
    .then(async groups => {
      if (groups.length === 0) {
        document
          .querySelector('#btn-create-post')
          .setAttribute('style', 'display:none')
      } else {
        if (USERS.length === 0) {
          const res = await window.fetch('/HR/api/getallusers.aspx')
          const data = await res.json()
          USERS = data.sort((a, b) => a.Fornamn.localeCompare(b.Efternamn))
        } else {
          return
        }

        setupGroups(groups)
        setupIndividualRecipients()
        setupExcludedGroups(groups)
        setupSearchGroups(groups)
        setupSearchExcludedGroups(groups)
        setupSearchIndividualRecipients()
      }

      const newsID = urlParams.get('id')
      const newsUrl =
        newsID === null
          ? `/HR/api/getmynews.aspx?limit=${NEWS_LIMIT}&offset=0`
          : `/HR/api/getmynews.aspx?id=${newsID}`

      window
        .fetch(newsUrl)
        .then(res => res.json())
        .then(newsDto => {
          nextOffset = newsDto.nextOffset || 0
          window
            .fetch('/HR/api/getmylikes.aspx')
            .then(res => res.json())
            .then(likes => {

              MY_LIKES = likes
              DATA = newsDto
              PAYLOAD = newsDto.items

              setupNews(PAYLOAD, false)
              setupSwiper()

              setupImages()
              setupVideo()
              setupLinks()
              setupPoll()
              setupAi()
              addEventListeners()
              setupModals()

              document.querySelector('#publication-date').value = setDateTime()

              document.querySelector('.skeleton-loading')?.remove()
              document.querySelector('.news-wrapper').classList.add('active')

              if (newsID !== null) {
                const newsInPayload = newsDto.items.filter(x => x.ID === Number(newsID))

                if (newsInPayload.length === 1) {
                  if (newsInPayload[0].IsSocialWall) {
                    setTimeout(() => {
                      document
                        .querySelector(
                          '.select-feed__btn[data-feed="socialWall"]'
                        )
                        ?.click()
                    }, 500)
                  }
                  setTimeout(() => {
                    openSingleNews(newsInPayload[0].ID)
                  }, 500)
                }
              }

              setupCKEditor()
              setupPullToRefresh()
            })
        })
        .catch(err => {
          console.error(err.message)
        })
    })
    .catch(err => console.error(err))
    .finally(() => {
      if (!useSocialWall) {
        return
      }

      if (feed !== null && feed === 'social-wall') {
        document.addEventListener('newsLoaded', () => {
          document
            .querySelector('.select-feed__btn[data-feed="socialWall"]')
            .click()
        })
      }
    })
}

getUser()
init()
Core.LockViewport()
